// sourced from http://a.sjc.k8s.wikia.net/interests-mapping/interests?unfiltered=false on 2023-09-20
export const interests = [
    {
        id: '2',
        name: 'Games',
        color: '#dfec24',
        image: {
            url: 'https://vignette.wikia.nocookie.net/820cb83b-d54e-41bf-a1ac-f83784dbad14',
            width: 1600,
            height: 1024,
        },
        wikis: ['1490', '182688'],
    },
    {
        id: '3',
        name: 'Horror',
        color: '#110e24',
        image: {
            url: 'https://static.wikia.nocookie.net/f47dd5fb-d181-44eb-bffa-d0aa6ad85a36',
            width: 1600,
            height: 1024,
        },
        wikis: ['353'],
    },
    {
        id: '4',
        name: 'HBO',
        color: '#372800',
        image: {
            url: 'https://static.wikia.nocookie.net/ef2b178b-3bf8-4a81-98cd-a7aab9d345cd',
            width: 1600,
            height: 1024,
        },
        wikis: [],
    },
    {
        id: '5',
        name: 'FIFA',
        color: '#329669',
        image: {
            url: 'https://static.wikia.nocookie.net/e8d16680-6eea-4c1f-8514-30d3a8c3d3a1',
            width: 1600,
            height: 1024,
        },
        wikis: ['12537', '22594'],
    },
    {
        id: '6',
        name: 'TV',
        color: '#00d6d6',
        image: {
            url: 'https://static.wikia.nocookie.net/e8496169-91ba-4499-9a0e-9d34cfdcd518',
            width: 1600,
            height: 1024,
        },
        wikis: ['671829'],
    },
    {
        id: '7',
        name: 'Comics',
        color: '#311724',
        image: {
            url: 'https://static.wikia.nocookie.net/e60db200-86f6-44ef-a293-7c93235779d5',
            width: 1600,
            height: 1024,
        },
        wikis: [],
    },
    {
        id: '8',
        name: 'Blizzard',
        color: '#f2f951',
        image: {
            url: 'https://static.wikia.nocookie.net/da83bc1e-a3ca-4508-990b-b8d39fc4db33',
            width: 1600,
            height: 1024,
        },
        wikis: [],
    },
    {
        id: '9',
        name: 'Game Trailers',
        color: '#008001',
        image: {
            url: 'https://static.wikia.nocookie.net/d483c9df-2fb6-4095-9b74-a8575a8c007f',
            width: 1600,
            height: 1024,
        },
        wikis: [],
    },
    {
        id: '600',
        name: 'Tokyo Revengers',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/eabe09b4-e2fc-4589-902a-4810ac227033',
            width: 1080,
            height: 1080,
        },
        wikis: ['2067434', '2123698', '2637386'],
    },
    {
        id: '601',
        name: 'Terraria Mods',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/15c3b7de-fe41-4414-8631-0f5301ccdb28',
            width: 1080,
            height: 1080,
        },
        wikis: ['2294772'],
    },
    {
        id: '602',
        name: 'Play Wild Item Worth',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/7ffa41e0-6237-4b15-9c4b-978870b9158e',
            width: 1080,
            height: 1080,
        },
        wikis: ['1594792'],
    },
    {
        id: '603',
        name: 'Stalker',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/44f22af4-bdc7-46c8-a32d-552c8d2a9a4a',
            width: 1080,
            height: 1080,
        },
        wikis: ['3489', '92916', '100807'],
    },
    {
        id: '604',
        name: 'Bloons',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/970b81e9-008b-400b-bdb4-90ffbd22b4b1',
            width: 1080,
            height: 1080,
        },
        wikis: ['27822', '922753'],
    },
    {
        id: '605',
        name: 'Metroid',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/3acd7043-9eca-4732-8971-3beec0fc9470',
            width: 1080,
            height: 1080,
        },
        wikis: ['635', '4166', '5332', '8079', '8538', '168482', '1322351'],
    },
    {
        id: '606',
        name: 'Bungo Stray Dogs',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/3b1e0e58-2a53-4a9f-b3c1-9cd2f8c60a95',
            width: 1080,
            height: 1080,
        },
        wikis: ['1020515', '1364832', '1417156'],
    },
    {
        id: '607',
        name: 'Aesthetics',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/677b1255-5c3f-4b13-a6fe-6d05d31b08bc',
            width: 1080,
            height: 1080,
        },
        wikis: ['1746940', '2456872'],
    },
    {
        id: '608',
        name: 'FTB',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/6eeb32fa-963b-476e-86ea-dc5dee826906',
            width: 1080,
            height: 1080,
        },
        wikis: ['2293798'],
    },
    {
        id: '609',
        name: 'Sound Effects',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/894c024d-38b4-4216-9a2f-882daf3766af',
            width: 1080,
            height: 1080,
        },
        wikis: ['916058'],
    },
    {
        id: '610',
        name: 'The Forest',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/6a4c1828-35c8-441a-a3a8-467cc24426df',
            width: 1080,
            height: 1080,
        },
        wikis: ['1184697', '2294177', '2294994'],
    },
    {
        id: '611',
        name: 'Pet Simulator',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b4be51c3-eef4-425a-8db6-01a77069b02f',
            width: 1080,
            height: 1080,
        },
        wikis: ['1781492'],
    },
    {
        id: '612',
        name: 'Danmachi',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/80ad0f98-424f-4ecb-9994-19bcd8af77a8',
            width: 1080,
            height: 1080,
        },
        wikis: ['1013286', '1136194', '1210785', '1334830', '2028368', '2050523'],
    },
    {
        id: '613',
        name: "Addam's Family",
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e7e60c74-73fc-4990-9208-71d06eda719b',
            width: 1080,
            height: 1080,
        },
        wikis: ['10445'],
    },
    {
        id: '614',
        name: 'Satisfactory',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f9026a07-b538-4f7c-a231-34ceff70f6cf',
            width: 1080,
            height: 1080,
        },
        wikis: ['2293503', '2293840', '2294664', '2295121'],
    },
    {
        id: '615',
        name: 'Kingdom Come: Deliverance',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/81d7bc17-6f1a-4162-9329-c728bc37ed9f',
            width: 1080,
            height: 1080,
        },
        wikis: ['1030879', '1654518', '1681738', '1691840'],
    },
    {
        id: '616',
        name: 'Undertale',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/0a8e3e63-2072-4871-8085-bf0a794596e0',
            width: 1080,
            height: 1080,
        },
        wikis: ['769303', '1282596', '1289615', '1301661', '1306031', '1326981'],
    },
    {
        id: '617',
        name: 'Record of Ragnarok',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/361ee839-2fc3-4cb9-9bf8-c4146d95a15a',
            width: 1080,
            height: 1080,
        },
        wikis: ['1902445', '1923744', '2699433'],
    },
    {
        id: '618',
        name: 'Enter the Gungeon',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/4a81e14e-4b7d-468f-85d3-788c48edafcd',
            width: 1080,
            height: 1080,
        },
        wikis: ['1385909', '2294856'],
    },
    {
        id: '619',
        name: 'Shameless',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/716a8a83-bb4a-4157-b1fd-c4fa6582ae0d',
            width: 1080,
            height: 1080,
        },
        wikis: ['7305', '1290621', '1339920'],
    },
    {
        id: '620',
        name: 'Paw Patrol',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/8ad96923-4ef1-4495-aec9-016845cbfa54',
            width: 1080,
            height: 1080,
        },
        wikis: ['801751'],
    },
    {
        id: '621',
        name: 'Haikyuu',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e2cd3b48-dff3-42f6-820b-40894454f27a',
            width: 1080,
            height: 1080,
        },
        wikis: ['525179', '740889', '954171', '1049718', '1122061', '1255099', '1500183'],
    },
    {
        id: '500',
        name: 'Dancing With The Stars',
        color: '#053566',
        image: {
            url: 'https://vignette.wikia.nocookie.net/38f3b25f-7d42-401a-bffd-4c5110195e26',
            width: 1600,
            height: 1024,
        },
        wikis: ['11027'],
    },
    {
        id: '622',
        name: 'Vocaloid Lyrics',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/0915aaa3-a731-4190-9c81-24148b6649aa',
            width: 1080,
            height: 1080,
        },
        wikis: ['22782'],
    },
    {
        id: '501',
        name: 'Real Racing 3',
        color: '#253131',
        image: {
            url: 'https://vignette.wikia.nocookie.net/73c880f9-87d3-459d-b673-7c20530b6321',
            width: 1600,
            height: 1024,
        },
        wikis: ['702401'],
    },
    {
        id: '623',
        name: 'Family Guy',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/46116ac1-b3a7-41de-b6a2-da08e20d2591',
            width: 1080,
            height: 1080,
        },
        wikis: ['376', '102744', '367649'],
    },
    {
        id: '502',
        name: "Milo Murphy's Law",
        color: '#a74c4c',
        image: {
            url: 'https://vignette.wikia.nocookie.net/cc857ef8-1987-4b4f-9224-cdfb9eeb0906',
            width: 1600,
            height: 1024,
        },
        wikis: ['1238023'],
    },
    {
        id: '624',
        name: 'Yandere Simulator',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e3e236a8-8332-4397-89fd-2abcd739c40a',
            width: 1080,
            height: 1080,
        },
        wikis: ['1149232', '1259513'],
    },
    {
        id: '503',
        name: "Marvel's Spider-Man",
        color: '#90e0ff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/9533b493-7507-460b-9ee9-50dc2872d361',
            width: 1600,
            height: 1024,
        },
        wikis: ['1777429'],
    },
    {
        id: '625',
        name: 'Berserk',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/512de9da-1209-447b-9911-fab65d273946',
            width: 1080,
            height: 1080,
        },
        wikis: ['7275', '428411'],
    },
    {
        id: '504',
        name: 'ABC',
        color: '#564054',
        image: {
            url: 'https://vignette.wikia.nocookie.net/2063b75a-1ffd-44cc-b832-ef7fea3a9b19',
            width: 1600,
            height: 1024,
        },
        wikis: ['9603'],
    },
    {
        id: '626',
        name: 'Squishmallows',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/a7aff7cb-5561-4b03-98db-1ad90cce0350',
            width: 1080,
            height: 1080,
        },
        wikis: ['2335454'],
    },
    {
        id: '505',
        name: 'Among Us',
        color: '#139829',
        image: {
            url: 'https://vignette.wikia.nocookie.net/56485f41-bc24-41ca-bd5f-33a6e3786081',
            width: 1600,
            height: 1024,
        },
        wikis: ['1988812', '2010685', '2366555'],
    },
    {
        id: '627',
        name: 'Military Wiki',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/088f8c62-1c83-425e-84df-a0a4ca4dc021',
            width: 1080,
            height: 1080,
        },
        wikis: ['104'],
    },
    {
        id: '506',
        name: 'Jumanji',
        color: '#2F5626',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f4b172f1-1556-439d-9ff8-f461468c6e1d',
            width: 1600,
            height: 1024,
        },
        wikis: ['569008'],
    },
    {
        id: '628',
        name: 'My Time at Portia',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ffc532e8-7d7b-4ea8-8e65-5a019a0532e9',
            width: 1080,
            height: 1080,
        },
        wikis: ['1597110', '1955130'],
    },
    {
        id: '507',
        name: 'Danganronpa',
        color: '#d4b7d7',
        image: {
            url: 'https://vignette.wikia.nocookie.net/7eb94c96-da89-4220-b664-52db74f79764',
            width: 1600,
            height: 1024,
        },
        wikis: ['613320', '797336', '1070740'],
    },
    {
        id: '629',
        name: 'Dead Space',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/886502f8-b541-4f6f-82f3-f52a111b7e2a',
            width: 1080,
            height: 1080,
        },
        wikis: ['6139', '8703', '71577', '472692', '811310'],
    },
    {
        id: '508',
        name: 'Genshin Impact',
        color: '#2d3248',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f0f7053d-95c5-4d27-8d34-65ff408cb600',
            width: 1600,
            height: 1024,
        },
        wikis: ['2025468', '2305793', '2402448', '2409003'],
    },
    {
        id: '509',
        name: 'The Good Place',
        color: '#7DA0AA',
        image: {
            url: 'https://vignette.wikia.nocookie.net/db54a831-4720-479b-a3ac-6e1619ea8a76',
            width: 1600,
            height: 1024,
        },
        wikis: ['1414508'],
    },
    {
        id: '630',
        name: 'King Legacy',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/03c1f21d-5dbb-479f-b262-0beb618c3a03',
            width: 1080,
            height: 1080,
        },
        wikis: ['2151252'],
    },
    {
        id: '631',
        name: 'Turtlepedia',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/fb916419-b76b-4f12-b720-5c827b4b587a',
            width: 1080,
            height: 1080,
        },
        wikis: ['2061', '29501', '270368', '950433', '971387'],
    },
    {
        id: '510',
        name: 'Kenshi',
        color: '#71655e',
        image: {
            url: 'https://vignette.wikia.nocookie.net/39c7a370-4b2f-4471-a710-6324f34a5600',
            width: 1600,
            height: 1024,
        },
        wikis: ['436144', '738844'],
    },
    {
        id: '632',
        name: 'Temtem',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/7ef24c37-681f-463a-bf4f-39e66f153241',
            width: 1080,
            height: 1080,
        },
        wikis: ['2293729', '2294213', '2294414', '2922858'],
    },
    {
        id: '511',
        name: "Baldur's Gate",
        color: '#A78955',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f14d0557-7ac9-400b-9c01-093bfab53b12',
            width: 1600,
            height: 1024,
        },
        wikis: ['458381'],
    },
    {
        id: '512',
        name: 'Hannibal',
        color: '#415181',
        image: {
            url: 'https://vignette.wikia.nocookie.net/fac67982-514f-451b-bc8f-14032dcf4c8e',
            width: 1600,
            height: 1024,
        },
        wikis: ['386650'],
    },
    {
        id: '634',
        name: 'Alice in Borderland',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/7cbcf30a-27a0-4065-aa8b-e4c9409dba54',
            width: 1080,
            height: 1080,
        },
        wikis: ['1039611'],
    },
    {
        id: '513',
        name: "Dawson's Creek",
        color: '#f6c97a',
        image: {
            url: 'https://vignette.wikia.nocookie.net/07edff05-49ec-4d39-b2e9-73a23de7e859',
            width: 1600,
            height: 1024,
        },
        wikis: ['118674'],
    },
    {
        id: '635',
        name: 'OMORI',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/0f7c46f5-11a0-4bfc-8627-b80a9ab6e459',
            width: 1080,
            height: 1080,
        },
        wikis: ['986117', '2624861', '2927946', '2928996'],
    },
    {
        id: '514',
        name: 'The Loud House',
        color: '#e88519',
        image: {
            url: 'https://vignette.wikia.nocookie.net/5562643a-86b7-467e-ba75-bede4f2acf29',
            width: 1600,
            height: 1024,
        },
        wikis: ['986551'],
    },
    {
        id: '636',
        name: 'Ultraman',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/4f884af4-1e74-489b-b442-5be4f5250146',
            width: 1080,
            height: 1080,
        },
        wikis: ['66452'],
    },
    {
        id: '515',
        name: 'Beavis and Butt-Head',
        color: '#ec3724',
        image: {
            url: 'https://vignette.wikia.nocookie.net/8b04642e-1c29-4107-89af-680a70845332',
            width: 1600,
            height: 1024,
        },
        wikis: ['1229'],
    },
    {
        id: '637',
        name: 'The Eminence In Shadow',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e66bd743-c0c5-485e-ba36-c6ba7f76bd3a',
            width: 1080,
            height: 1080,
        },
        wikis: ['1842963'],
    },
    {
        id: '516',
        name: 'Critical Role',
        color: '#79b4ff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/9bb7da6c-d6d8-4a04-8dc5-11e01158512b',
            width: 1600,
            height: 1024,
        },
        wikis: ['1163770'],
    },
    {
        id: '638',
        name: 'Hades',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/23ba3404-e476-48c6-9565-d740c91d917b',
            width: 1080,
            height: 1080,
        },
        wikis: ['1883152', '2293902', '2598945'],
    },
    {
        id: '517',
        name: 'Cyberpunk',
        color: '#FDF701',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e3b7a376-e997-4486-bb94-4f4d0c33c4fb',
            width: 1600,
            height: 1024,
        },
        wikis: ['241546', '1040029', '1454283'],
    },
    {
        id: '639',
        name: 'Rwby',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/8e962ee6-6f7b-47a9-9bf5-4b74f4a03f2e',
            width: 1080,
            height: 1080,
        },
        wikis: ['632746', '776328', '1006255', '1016809', '1211661'],
    },
    {
        id: '518',
        name: 'Harvest Moon',
        color: '#86D2DD',
        image: {
            url: 'https://vignette.wikia.nocookie.net/6425d066-dc0e-44bf-ba17-daadf564c77f',
            width: 1600,
            height: 1024,
        },
        wikis: ['997'],
    },
    {
        id: '519',
        name: 'Yo-kai Watch',
        color: '#6B9FEA',
        image: {
            url: 'https://vignette.wikia.nocookie.net/8dfa8829-a89f-415d-9f64-c8f1475da363',
            width: 1600,
            height: 1024,
        },
        wikis: ['675059'],
    },
    {
        id: '640',
        name: 'Dead Cells',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/6bc8c5a2-6bef-40cb-aba0-d240b0a02bf4',
            width: 1080,
            height: 1080,
        },
        wikis: ['1571043', '2293226', '2294644', '2295095'],
    },
    {
        id: '520',
        name: "Hell's Kitchen",
        color: '#353431',
        image: {
            url: 'https://vignette.wikia.nocookie.net/353983c7-bf44-4849-864d-0bfaf125652d',
            width: 1600,
            height: 1024,
        },
        wikis: ['106194'],
    },
    {
        id: '642',
        name: 'Ncis',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/952d15d0-14a7-42bc-ab57-d37dc6ee75ae',
            width: 1080,
            height: 1080,
        },
        wikis: ['2257', '351967'],
    },
    {
        id: '521',
        name: 'Castlevania',
        color: '#4D1A18',
        image: {
            url: 'https://vignette.wikia.nocookie.net/72924e30-a348-45e1-b577-775bfdabe606',
            width: 1600,
            height: 1024,
        },
        wikis: ['1407', '6884'],
    },
    {
        id: '400',
        name: 'Pixar',
        color: '#56bce9',
        image: {
            url: 'https://vignette.wikia.nocookie.net/6a209276-fcbe-4580-9585-be287f498186',
            width: 1600,
            height: 1024,
        },
        wikis: ['4097', '9955', '179047', '191069', '1023679'],
    },
    {
        id: '643',
        name: 'Skyrim',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/d1a96533-c80c-41ed-a4ab-e9c947c8cf80',
            width: 1080,
            height: 1080,
        },
        wikis: ['2294501', '2294596'],
    },
    {
        id: '522',
        name: 'Just Dance',
        color: '#3F2770',
        image: {
            url: 'https://vignette.wikia.nocookie.net/a73391d0-a6d3-4e96-ab5e-e34d20ccb791',
            width: 1600,
            height: 1024,
        },
        wikis: ['130547'],
    },
    {
        id: '401',
        name: 'The Promised Neverland',
        color: '#523220',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ea08a00f-3ae6-46f5-93bc-96eeaefa3e0a',
            width: 1600,
            height: 1024,
        },
        wikis: ['1440181', '1483187', '1655409', '1664473'],
    },
    {
        id: '644',
        name: "Hogwart's Legacy",
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/13756aad-179e-4c1e-ab3c-f9490d16a94d',
            width: 1080,
            height: 1080,
        },
        wikis: ['3129914', '3149446'],
    },
    {
        id: '523',
        name: 'Fate: The Winx Saga',
        color: '#1d283d',
        image: {
            url: 'https://vignette.wikia.nocookie.net/4d49aafb-ce20-4592-b31b-b72f32611805',
            width: 1600,
            height: 1024,
        },
        wikis: ['2073723'],
    },
    {
        id: '402',
        name: 'Rooster Teeth',
        color: '#dd3522',
        image: {
            url: 'https://vignette.wikia.nocookie.net/18e5cca3-8ead-4ba9-b711-d99b6e3ce730',
            width: 1600,
            height: 1024,
        },
        wikis: ['14007'],
    },
    {
        id: '645',
        name: 'Atomic Heart',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/81ccf6c4-caf9-4f63-ae51-6f1142684f6e',
            width: 1080,
            height: 1080,
        },
        wikis: ['2294976', '2481072'],
    },
    {
        id: '524',
        name: 'Re:Zero',
        color: '#c963c3',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f4444db4-4f45-407b-b40b-4d48c32de83e',
            width: 1600,
            height: 1024,
        },
        wikis: ['1138138', '1446586', '2441765'],
    },
    {
        id: '403',
        name: 'K Pop',
        color: '#ef3aa3',
        image: {
            url: 'https://vignette.wikia.nocookie.net/04b3511c-861e-47c1-a368-374224fe339d',
            width: 1600,
            height: 1024,
        },
        wikis: ['113354', '1691407'],
    },
    {
        id: '646',
        name: 'Astroneer',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/bcc17904-0612-425d-9b74-4006e9b617c8',
            width: 1080,
            height: 1080,
        },
        wikis: ['2293233', '2293456', '2293572', '2293611', '2293654', '2294266', '2294783', '2294786', '2295058'],
    },
    {
        id: '525',
        name: 'Power',
        color: '#5A7569',
        image: {
            url: 'https://vignette.wikia.nocookie.net/659f011c-bbb6-4907-9865-ddacace4ce93',
            width: 1600,
            height: 1024,
        },
        wikis: ['1253574'],
    },
    {
        id: '404',
        name: 'BoJack Horseman',
        color: '#d9bbd8',
        image: {
            url: 'https://vignette.wikia.nocookie.net/5baf4abc-1af2-4b21-86b2-98f07f014fe1',
            width: 745,
            height: 477,
        },
        wikis: ['1031035'],
    },
    {
        id: '647',
        name: 'Death Note',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/944c5185-d7ab-4504-aef4-fb9a5801741d',
            width: 1080,
            height: 1080,
        },
        wikis: ['3581', '6401', '13339', '45130', '146688', '417335', '535081'],
    },
    {
        id: '526',
        name: 'White Wolf',
        color: '#6A6F80',
        image: {
            url: 'https://vignette.wikia.nocookie.net/84e3cb19-8dfe-4b3d-8c38-63e4aa5016a4',
            width: 1600,
            height: 1024,
        },
        wikis: ['381'],
    },
    {
        id: '405',
        name: 'Seraph of the End',
        color: '#85b83c',
        image: {
            url: 'https://vignette.wikia.nocookie.net/9b5ba80c-104c-4f88-8938-a6e45d65a523',
            width: 745,
            height: 477,
        },
        wikis: ['729761', '1033383', '1168200', '1209647'],
    },
    {
        id: '648',
        name: 'Pj Masks',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/d0018d9a-bbc5-499c-9f26-5e5fe353c679',
            width: 1080,
            height: 1080,
        },
        wikis: ['1269658'],
    },
    {
        id: '527',
        name: 'Evangelion',
        color: '#c94ccc',
        image: {
            url: 'https://vignette.wikia.nocookie.net/410e8320-73f0-48d6-a4ce-e66ad2375c35',
            width: 1600,
            height: 1024,
        },
        wikis: ['4084', '581683'],
    },
    {
        id: '406',
        name: 'Wizards Unite',
        color: '#293657',
        image: {
            url: 'https://vignette.wikia.nocookie.net/21d90267-4581-40fa-9945-952de50b5edd',
            width: 1600,
            height: 1024,
        },
        wikis: ['2019539'],
    },
    {
        id: '649',
        name: 'Skullgirls',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/80a22b99-d8a5-4597-b147-3903b5a8e5af',
            width: 1080,
            height: 1080,
        },
        wikis: ['284111', '1090994', '1210114'],
    },
    {
        id: '528',
        name: "So I'm a Spider, So What?",
        color: '#b0f9ee',
        image: {
            url: 'https://vignette.wikia.nocookie.net/cc269a6c-fdff-436e-98aa-7b061b48556d',
            width: 1600,
            height: 1024,
        },
        wikis: ['1352725'],
    },
    {
        id: '407',
        name: 'A Million Little Things',
        color: '#597e96',
        image: {
            url: 'https://vignette.wikia.nocookie.net/51a3bd92-7433-42a5-afed-05b4d1912ef4',
            width: 1600,
            height: 1024,
        },
        wikis: ['1733992'],
    },
    {
        id: '529',
        name: 'Princess Connect',
        color: '#7cf9e6',
        image: {
            url: 'https://vignette.wikia.nocookie.net/960bd8ca-69e9-4efd-b22d-29dadc0325b9',
            width: 672,
            height: 951,
        },
        wikis: ['1687255'],
    },
    {
        id: '408',
        name: 'John Wick',
        color: '#5ea0ad',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e0db72b2-591b-4c67-8efe-8ec1801895dd',
            width: 1600,
            height: 1024,
        },
        wikis: ['1459949'],
    },
    {
        id: '409',
        name: 'Rambo',
        color: '#7b8265',
        image: {
            url: 'https://vignette.wikia.nocookie.net/31d64e22-faf5-4daa-83c2-de8ec67f9474',
            width: 1600,
            height: 1024,
        },
        wikis: ['7847'],
    },
    {
        id: '650',
        name: 'Boruto',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/3505059d-687f-4df7-9cd7-f5d9f3a383fc',
            width: 1080,
            height: 1080,
        },
        wikis: ['1071798'],
    },
    {
        id: '651',
        name: 'Leaguepedia',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c683070a-21b0-487b-aa1f-1152a602d0a3',
            width: 1080,
            height: 1080,
        },
        wikis: ['2293615'],
    },
    {
        id: '530',
        name: 'Barbie Animated Movies',
        color: '#532e83',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c6e5d862-452a-41b0-93e5-2584c5de7385',
            width: 672,
            height: 951,
        },
        wikis: ['157124'],
    },
    {
        id: '652',
        name: 'Funkipedia Mods',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/2ca85140-48bb-4826-93f3-59f903cb2529',
            width: 1080,
            height: 1080,
        },
        wikis: ['2548928', '2600614', '2619674', '2670043', '2751543'],
    },
    {
        id: '531',
        name: 'Romance Club',
        color: '#7371bd',
        image: {
            url: 'https://vignette.wikia.nocookie.net/8c0f1fde-210b-4781-bfa8-13710e26d8e5',
            width: 1600,
            height: 1024,
        },
        wikis: ['1868774', '1871175'],
    },
    {
        id: '410',
        name: 'Saw',
        color: '#a72a29',
        image: {
            url: 'https://vignette.wikia.nocookie.net/6e5d551f-4891-49eb-8c64-e94cac8f84f6',
            width: 1600,
            height: 1024,
        },
        wikis: ['2143'],
    },
    {
        id: '653',
        name: 'Everquest 2',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/45d515d4-9e48-48ea-baa7-89490a5c1ee8',
            width: 1080,
            height: 1080,
        },
        wikis: ['324', '3591', '6239', '923606'],
    },
    {
        id: '532',
        name: 'Dead by Daylight',
        color: '#1f1830',
        image: {
            url: 'https://vignette.wikia.nocookie.net/9ea54a47-624a-476b-9276-42a33cfa1b1f',
            width: 1600,
            height: 1024,
        },
        wikis: ['1410320', '2294132'],
    },
    {
        id: '411',
        name: 'Stumptown',
        color: '#2e848f',
        image: {
            url: 'https://vignette.wikia.nocookie.net/94830f0c-80c7-4db4-a32e-3b16868fa754',
            width: 1600,
            height: 1024,
        },
        wikis: ['2011293'],
    },
    {
        id: '654',
        name: 'Nickstory',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/53aa5b61-6ba4-416a-bb72-b4b91d40efad',
            width: 1080,
            height: 1080,
        },
        wikis: ['2151342'],
    },
    {
        id: '533',
        name: 'ZELDA_MW1.37',
        color: '#008001',
        image: {
            url: 'https://static.wikia.nocookie.net/b4c29200-ca21-4306-aa0c-c59330c7890d',
            width: 1600,
            height: 1024,
        },
        wikis: ['2885568'],
    },
    {
        id: '412',
        name: 'Dman',
        color: '#ffffff',
        image: {
            url: 'https://static.wikia.nocookie.net/df1125a6-95e1-448a-b608-9010774cf1b8',
            width: 1600,
            height: 1024,
        },
        wikis: ['1362703'],
    },
    {
        id: '655',
        name: "Nico'S Nextbots",
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/04f26d4e-423f-49b3-a4c3-e5538600eb40',
            width: 1080,
            height: 1080,
        },
        wikis: ['3015256'],
    },
    {
        id: '534',
        name: 'KEIKO-TEST_MW1.37',
        color: '#4251f5',
        image: {
            url: 'https://static.wikia.nocookie.net/keikosandbox/images/0/06/Latte_art.jpg/revision/latest',
            width: 670,
            height: 360,
        },
        wikis: ['2940831'],
    },
    {
        id: '413',
        name: "Keiko's Test",
        color: '#4251f5',
        image: {
            url: 'https://static.wikia.nocookie.net/keikosandbox/images/0/06/Latte_art.jpg/revision/latest',
            width: 670,
            height: 360,
        },
        wikis: ['1081891'],
    },
    {
        id: '656',
        name: 'Christmas Specials',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/55a563ab-ab3e-4d4b-b625-3de8af85be6f',
            width: 1080,
            height: 1080,
        },
        wikis: ['4490'],
    },
    {
        id: '535',
        name: 'Death Battle',
        color: '#b682ae',
        image: {
            url: 'https://vignette.wikia.nocookie.net/80b352ab-2c5b-421d-bfcc-807cd0fda796',
            width: 1600,
            height: 1024,
        },
        wikis: ['291156'],
    },
    {
        id: '414',
        name: 'Bachelor Nation',
        color: '#510a1e',
        image: {
            url: 'https://vignette.wikia.nocookie.net/51d9c58d-43a5-4311-8f60-39b82b387fda',
            width: 1600,
            height: 1024,
        },
        wikis: ['1192046'],
    },
    {
        id: '657',
        name: 'Bendy',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/be5d80a7-962e-484e-8198-7166b0b04e41',
            width: 1080,
            height: 1080,
        },
        wikis: ['1532078', '1550804', '1554786'],
    },
    {
        id: '536',
        name: 'keiko-test_MW1.39',
        color: '#4251f5',
        image: {
            url: 'https://static.wikia.nocookie.net/keikosandbox/images/0/06/Latte_art.jpg/revision/latest',
            width: 670,
            height: 360,
        },
        wikis: ['3144780'],
    },
    {
        id: '415',
        name: 'Code Geass',
        color: '#ac0f94',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c445273e-e690-463d-a7f7-04bc39a0fc4e',
            width: 1600,
            height: 1024,
        },
        wikis: ['6877', '33041', '75457', '131666', '1098455'],
    },
    {
        id: '658',
        name: 'Poppy Playtime',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/805c9caf-6cf1-4485-8457-c169a2620e77',
            width: 1080,
            height: 1080,
        },
        wikis: ['2810570'],
    },
    {
        id: '537',
        name: 'Sucker Punch',
        color: '#487e56',
        image: {
            url: 'https://vignette.wikia.nocookie.net/77683b01-1883-4e32-9300-eff89488f57b',
            width: 1600,
            height: 1024,
        },
        wikis: ['150349'],
    },
    {
        id: '416',
        name: 'Death Stranding',
        color: '#b5d7f2',
        image: {
            url: 'https://vignette.wikia.nocookie.net/d22a911b-b742-4104-a2bd-fa0c567f1cf9',
            width: 1600,
            height: 1024,
        },
        wikis: ['1416122', '1499584'],
    },
    {
        id: '659',
        name: 'Identity V',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b9770f46-2904-4f13-ac41-b35e9c2ce30d',
            width: 1080,
            height: 1080,
        },
        wikis: ['1665589', '2090674', '2164397'],
    },
    {
        id: '538',
        name: 'Armyverse',
        color: '#a9a461',
        image: {
            url: 'https://vignette.wikia.nocookie.net/3230230f-ec32-4c85-aa90-1b2bbddac620',
            width: 1600,
            height: 1024,
        },
        wikis: ['2501856'],
    },
    {
        id: '417',
        name: 'Dora',
        color: '#f7da35',
        image: {
            url: 'https://vignette.wikia.nocookie.net/897a8795-439b-4ffd-9da0-49e56fe8ba0a',
            width: 1600,
            height: 1024,
        },
        wikis: ['9577'],
    },
    {
        id: '539',
        name: 'Demon Accords',
        color: '#4b6862',
        image: {
            url: 'https://vignette.wikia.nocookie.net/12fcdddf-6526-48f8-8d24-b9623b8c86ab',
            width: 1600,
            height: 1024,
        },
        wikis: ['1713584'],
    },
    {
        id: '418',
        name: 'Forge of Empires',
        color: '#727338',
        image: {
            url: 'https://vignette.wikia.nocookie.net/838f9ba8-682f-429e-8e99-7b8a5be9e8a5',
            width: 1600,
            height: 1024,
        },
        wikis: ['435722', '530976', '622423'],
    },
    {
        id: '419',
        name: 'Jurassic World Evolution',
        color: '#44596d',
        image: {
            url: 'https://vignette.wikia.nocookie.net/2047b4ba-e22b-43d9-b49d-2ba49a1039fe',
            width: 1600,
            height: 1024,
        },
        wikis: ['1719113'],
    },
    {
        id: '660',
        name: 'Dubbing Database',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/19d13b61-1139-4890-8c53-0a27a1d8c722',
            width: 1080,
            height: 1080,
        },
        wikis: ['1235199'],
    },
    {
        id: '661',
        name: 'Nickelodeon',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e182458f-a883-4e41-8dcc-2232529d06ab',
            width: 1080,
            height: 1080,
        },
        wikis: ['339', '12286'],
    },
    {
        id: '540',
        name: 'Zack Snyder',
        color: '#0d3f58',
        image: {
            url: 'https://vignette.wikia.nocookie.net/d4d4dc10-9a5c-4e3b-8bc2-68299c0afc9a',
            width: 1600,
            height: 1024,
        },
        wikis: ['2721493'],
    },
    {
        id: '662',
        name: 'Death Battle Fanon',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/7f7aaae8-0f17-4238-b42e-9230f77064a8',
            width: 1080,
            height: 1080,
        },
        wikis: ['812244'],
    },
    {
        id: '541',
        name: 'For All Mankind',
        color: '#371200',
        image: {
            url: 'https://vignette.wikia.nocookie.net/79be22fa-ef7a-49e8-b605-ea9de56b1537',
            width: 1600,
            height: 1024,
        },
        wikis: ['2010886'],
    },
    {
        id: '420',
        name: 'Pro Wrestling',
        color: '#2340b4',
        image: {
            url: 'https://vignette.wikia.nocookie.net/bf8ff827-6c22-4ea3-8a6e-34810ac58ef8',
            width: 1600,
            height: 1024,
        },
        wikis: ['283', '20049'],
    },
    {
        id: '663',
        name: 'Treasure Island',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/339c904e-b3cf-48e5-a149-e32e7b028b5b',
            width: 1080,
            height: 1080,
        },
        wikis: ['1624596'],
    },
    {
        id: '542',
        name: 'Need for Speed',
        color: '#01db00',
        image: {
            url: 'https://vignette.wikia.nocookie.net/2dc8b3dd-5c5f-4366-9a54-14da1a24adbf',
            width: 1600,
            height: 1024,
        },
        wikis: ['1383', '715122'],
    },
    {
        id: '421',
        name: 'She-Ra and the Princesses of Power',
        color: '#1fb6fc',
        image: {
            url: 'https://vignette.wikia.nocookie.net/a657592b-a065-49bb-ae67-e52ba0abb9f9',
            width: 1600,
            height: 1024,
        },
        wikis: ['1785142'],
    },
    {
        id: '300',
        name: 'Percy Jackson & the Olympians',
        color: '#4fb3c0',
        image: {
            url: 'https://vignette.wikia.nocookie.net/50f337a7-0c6e-4d87-9d82-8ec58b05ea1f',
            width: 1600,
            height: 1024,
        },
        wikis: ['3313', '200298', '203069', '324283', '463468', '667029'],
    },
    {
        id: '664',
        name: 'Supermariologan',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/07a86b03-b32e-416e-bf64-e83df0459aaf',
            width: 1080,
            height: 1080,
        },
        wikis: ['42655'],
    },
    {
        id: '543',
        name: 'Raft',
        color: '#3b9ba7',
        image: {
            url: 'https://vignette.wikia.nocookie.net/1ec917c9-5ee4-4a8e-838c-6b700a10642f',
            width: 1600,
            height: 1024,
        },
        wikis: ['2051583', '2293859'],
    },
    {
        id: '422',
        name: 'Tales of Arcadia',
        color: '#38a2d7',
        image: {
            url: 'https://vignette.wikia.nocookie.net/16d61886-b191-439b-9bd6-a63fd309fcf3',
            width: 1600,
            height: 1024,
        },
        wikis: ['1493759'],
    },
    {
        id: '301',
        name: 'YouTube',
        color: '#d92525',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f90ff2ed-2b3d-4cda-a123-759138623a26',
            width: 1600,
            height: 1024,
        },
        wikis: ['2575', '47276', '575144', '933220', '1112378'],
    },
    {
        id: '665',
        name: 'Mobile Legends',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c1d5dc89-df52-4136-868f-caf1fbcd0a03',
            width: 1080,
            height: 1080,
        },
        wikis: ['1474043'],
    },
    {
        id: '544',
        name: 'Vampire Survivors',
        color: '#771e16',
        image: {
            url: 'https://vignette.wikia.nocookie.net/3b1a5f88-8ed2-4285-870c-48ef8de31561',
            width: 1600,
            height: 1024,
        },
        wikis: ['2814820'],
    },
    {
        id: '423',
        name: 'The Outer Worlds',
        color: '#3f4222',
        image: {
            url: 'https://vignette.wikia.nocookie.net/54636079-b97c-4df9-859c-d5ecff1976f5',
            width: 1600,
            height: 1024,
        },
        wikis: ['1878705', '1881937', '2074591'],
    },
    {
        id: '302',
        name: 'House of Cards',
        color: '#173698',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b33395ef-a22a-4786-a5a0-fd4760175ae4',
            width: 1600,
            height: 1024,
        },
        wikis: ['670464', '835553', '996484', '1114194', '1391192', '1514154'],
    },
    {
        id: '666',
        name: 'Bluey',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e2e085f6-3413-44b2-8717-e88c9a55ed36',
            width: 1080,
            height: 1080,
        },
        wikis: ['1908583'],
    },
    {
        id: '545',
        name: 'Blox Fruits',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/12d88ed7-c06c-4bc9-b5db-d7c6aafee616',
            width: 1080,
            height: 1080,
        },
        wikis: ['2009968', '3067084'],
    },
    {
        id: '424',
        name: 'Dark Crystal',
        color: '#a06096',
        image: {
            url: 'https://vignette.wikia.nocookie.net/1cf67302-56e5-4a01-99bb-7a30d77a94ed',
            width: 1600,
            height: 1024,
        },
        wikis: ['6888'],
    },
    {
        id: '303',
        name: 'Heroes TV',
        color: '#1e88b2',
        image: {
            url: 'https://vignette.wikia.nocookie.net/8c1d40de-f2c0-4b74-a4fb-60b44b24c3da',
            width: 1600,
            height: 1024,
        },
        wikis: ['1550'],
    },
    {
        id: '667',
        name: 'Peaky Blinders',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/548f8931-f654-43d6-a697-facbec2cbfeb',
            width: 1080,
            height: 1080,
        },
        wikis: ['867920', '1880301'],
    },
    {
        id: '546',
        name: 'Escape From Tarkov',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/5606c703-bca5-42cc-9800-1f91656ce02e',
            width: 1080,
            height: 1080,
        },
        wikis: ['2293523', '2293652', '2293740', '2293881', '2295346'],
    },
    {
        id: '304',
        name: 'Monster Legends',
        color: '#eb7a29',
        image: {
            url: 'https://vignette.wikia.nocookie.net/bf1d9241-6aa9-4fe4-b855-00b4d1733571',
            width: 1600,
            height: 1024,
        },
        wikis: ['752307', '752757', '1389094'],
    },
    {
        id: '668',
        name: 'House M.D.',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/bac0f305-721d-4cb3-92fa-841d3b807955',
            width: 1080,
            height: 1080,
        },
        wikis: ['1845', '6710', '43551'],
    },
    {
        id: '547',
        name: 'All Star Tower Defense',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/6995a498-a1e8-4d1a-9ee9-5c711ddbffeb',
            width: 1080,
            height: 1080,
        },
        wikis: ['2416143'],
    },
    {
        id: '426',
        name: 'Stephen King',
        color: '#8f0000',
        image: {
            url: 'https://vignette.wikia.nocookie.net/2c22dcbc-8f7c-43ef-add5-0c4bdb53a940',
            width: 1600,
            height: 1024,
        },
        wikis: ['2459', '1458067'],
    },
    {
        id: '305',
        name: 'Sci-Fi',
        color: '#1f414f',
        image: {
            url: 'https://vignette.wikia.nocookie.net/1e6081f3-c572-42c8-ad17-2a681967e35f',
            width: 1600,
            height: 1024,
        },
        wikis: [],
    },
    {
        id: '669',
        name: 'Gossip Girl',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/7873bd24-62c7-460f-ac3a-63669837f5db',
            width: 1080,
            height: 1080,
        },
        wikis: ['6913'],
    },
    {
        id: '548',
        name: 'ARK',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f879e572-fe36-4e75-86a5-3cfd5b1f68ce',
            width: 1080,
            height: 1080,
        },
        wikis: ['2293230', '2293727', '2294188', '2294191', '2294513', '2294814', '2295348'],
    },
    {
        id: '427',
        name: 'Watchmen',
        color: '#430f82',
        image: {
            url: 'https://vignette.wikia.nocookie.net/a996fa73-7db7-47b8-843a-f2056da1cf85',
            width: 1600,
            height: 1024,
        },
        wikis: ['8247'],
    },
    {
        id: '549',
        name: 'Calamity Mod',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/dd2ae19a-fc19-41c8-a910-7a58f84266d8',
            width: 1080,
            height: 1080,
        },
        wikis: ['1485044', '1725976', '2293362'],
    },
    {
        id: '428',
        name: 'Mindhunter',
        color: '#94b7c7',
        image: {
            url: 'https://vignette.wikia.nocookie.net/559c34b8-416a-42af-9855-2d0d0f111bf9',
            width: 1600,
            height: 1024,
        },
        wikis: ['1563698', '1622054'],
    },
    {
        id: '429',
        name: 'Sasuke Ninja Warrior',
        color: '#01266a',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b77d94cb-2090-4ff2-8fd7-613eb20d1ed9',
            width: 1600,
            height: 1024,
        },
        wikis: ['29116'],
    },
    {
        id: '308',
        name: 'Once Upon a Time',
        color: '#062852',
        image: {
            url: 'https://vignette.wikia.nocookie.net/4273a68c-834c-4356-8130-5c5be818fbfb',
            width: 1600,
            height: 1024,
        },
        wikis: ['342218', '453944', '501645', '507951', '554145', '617998', '665708'],
    },
    {
        id: '309',
        name: 'Shadowhunters',
        color: '#516469',
        image: {
            url: 'https://vignette.wikia.nocookie.net/7e91c931-ee68-413f-8006-20247d8dda8d',
            width: 1600,
            height: 1024,
        },
        wikis: ['12244', '600872', '671184', '675658', '684464', '770701'],
    },
    {
        id: '670',
        name: 'Pokemon GO',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/2b669d07-29e9-4cfc-8c48-6a641359fde3',
            width: 1080,
            height: 1080,
        },
        wikis: ['1264460', '1370671', '1476252', '2293583'],
    },
    {
        id: '671',
        name: 'Alphabet Lore',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/143d233c-d2f2-4c33-91fd-e0f937828ea8',
            width: 1080,
            height: 1080,
        },
        wikis: ['3044771'],
    },
    {
        id: '550',
        name: 'Anime Adventures',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/4d0e6021-fb36-43f8-b2c9-ba772b42836e',
            width: 1080,
            height: 1080,
        },
        wikis: ['3010347'],
    },
    {
        id: '551',
        name: 'Chainsaw Man',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/067f7fb3-e3ea-4e44-b907-2e9334a09ffd',
            width: 1080,
            height: 1080,
        },
        wikis: ['1872851', '2055443', '2264933'],
    },
    {
        id: '430',
        name: "Dragon's Dogma",
        color: '#4b678f',
        image: {
            url: 'https://vignette.wikia.nocookie.net/3faa186c-f8f8-4074-8a30-326829ceb780',
            width: 1600,
            height: 1024,
        },
        wikis: ['249580', '540640', '543189', '654268'],
    },
    {
        id: '552',
        name: 'Valheim',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/4b8f3b86-1471-4963-9019-f29227c08a4c',
            width: 1080,
            height: 1080,
        },
        wikis: ['1736232', '2543125', '2545726', '2551475'],
    },
    {
        id: '431',
        name: 'Jailbreak',
        color: '#429afb',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e568938f-31e9-4dd3-80b4-fcddd6376d5b',
            width: 1600,
            height: 1024,
        },
        wikis: ['1564796'],
    },
    {
        id: '310',
        name: 'Shin Megami Tensei',
        color: '#e21818',
        image: {
            url: 'https://vignette.wikia.nocookie.net/24915e1f-d5a7-4c1e-8b51-5eb783706771',
            width: 1600,
            height: 1024,
        },
        wikis: ['5813', '11559'],
    },
    {
        id: '553',
        name: 'Deepwoken',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/d9949c4e-3541-4146-9d3d-fe4ae7c9f9de',
            width: 1080,
            height: 1080,
        },
        wikis: ['2129932'],
    },
    {
        id: '432',
        name: 'Animation',
        color: '#4297e0',
        image: {
            url: 'https://vignette.wikia.nocookie.net/8ba1e8fb-1802-46fe-86dc-c2066029bf84',
            width: 1600,
            height: 1024,
        },
        wikis: [],
    },
    {
        id: '311',
        name: 'Buddyfight',
        color: '#c11e1e',
        image: {
            url: 'https://vignette.wikia.nocookie.net/3189098b-9fe8-49fb-88a2-5e5516640563',
            width: 1600,
            height: 1024,
        },
        wikis: ['824677'],
    },
    {
        id: '554',
        name: 'Elden Ring',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/a8a2ffd5-04d8-4a41-be86-b0930799ee40',
            width: 1080,
            height: 1080,
        },
        wikis: ['2009173', '2632489', '2707915', '2923191'],
    },
    {
        id: '433',
        name: 'Modern Family',
        color: '#b7d6eb',
        image: {
            url: 'https://vignette.wikia.nocookie.net/42d13c2d-de72-40c2-bcb2-162ac74c75bb',
            width: 1600,
            height: 1024,
        },
        wikis: ['55445', '516901'],
    },
    {
        id: '312',
        name: 'Hero Database',
        color: '#f2172b',
        image: {
            url: 'https://vignette.wikia.nocookie.net/648837a6-be46-4426-a267-6b6499abd1bc',
            width: 1600,
            height: 1024,
        },
        wikis: ['20780'],
    },
    {
        id: '555',
        name: 'Battle Cats',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/2ed4efc2-1d28-4bff-93a1-37ea01a98a88',
            width: 1080,
            height: 1080,
        },
        wikis: ['691085', '1513192'],
    },
    {
        id: '434',
        name: 'Growtopia',
        color: '#44d1e6',
        image: {
            url: 'https://vignette.wikia.nocookie.net/bc57557f-5afb-48be-8800-74b3aa5f22a4',
            width: 1600,
            height: 1024,
        },
        wikis: ['653222'],
    },
    {
        id: '313',
        name: 'Puzzle and Dragons',
        color: '#ffdb0f',
        image: {
            url: 'https://vignette.wikia.nocookie.net/27d1e8a5-5292-4211-bc3b-c76ea48f614d',
            width: 1600,
            height: 1024,
        },
        wikis: ['658287'],
    },
    {
        id: '556',
        name: 'Drama',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f1b15410-b356-4b2e-a118-f7e839b348d0',
            width: 1080,
            height: 1080,
        },
        wikis: ['10739', '14316', '178518'],
    },
    {
        id: '435',
        name: "Charlie's Angels",
        color: '#fde2c2',
        image: {
            url: 'https://vignette.wikia.nocookie.net/703aed33-4f3c-4d52-89d0-06bf00a3dae4',
            width: 1600,
            height: 1024,
        },
        wikis: ['11721'],
    },
    {
        id: '314',
        name: 'Resident Evil',
        color: '#6b6b6b',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c778ab17-7c4d-4934-bde0-02a4663c2315',
            width: 1600,
            height: 1024,
        },
        wikis: ['1249', '5372', '5458', '49401', '50591', '410236'],
    },
    {
        id: '557',
        name: 'Hypixel SkyBlock',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c534abf8-8b48-41c8-a3f8-ecba274594a9',
            width: 1080,
            height: 1080,
        },
        wikis: ['2011605', '2099083', '2118465', '2181859'],
    },
    {
        id: '436',
        name: 'Kimetsu no Yaiba',
        color: '#6bd4aa',
        image: {
            url: 'https://vignette.wikia.nocookie.net/01711c3e-3948-4461-a087-8f194a0312a1',
            width: 1600,
            height: 1024,
        },
        wikis: ['1358984', '1964962'],
    },
    {
        id: '315',
        name: 'Ajin Demi Human',
        color: '#0f6281',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f459400b-3c65-4e40-a608-8bffeee16956',
            width: 1600,
            height: 1024,
        },
        wikis: ['830511'],
    },
    {
        id: '558',
        name: 'Binding of Isaac: Rebirth',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/3cc0e21f-9033-4db6-8683-87be7e3bb119',
            width: 1080,
            height: 1080,
        },
        wikis: ['454463', '458479', '491937', '544824', '2293481'],
    },
    {
        id: '437',
        name: 'Star Wars Jedi: Fallen Order',
        color: '#024F92',
        image: {
            url: 'https://vignette.wikia.nocookie.net/a79146c6-4f5d-491d-8766-c042fd7a797b',
            width: 1600,
            height: 1024,
        },
        wikis: ['1751804', '2077526'],
    },
    {
        id: '316',
        name: 'Fantasy',
        color: '#4f675e',
        image: {
            url: 'https://vignette.wikia.nocookie.net/9f009ca6-7f4f-4de5-85b9-a9b55fa2ef30',
            width: 1600,
            height: 1024,
        },
        wikis: [],
    },
    {
        id: '559',
        name: 'Project SEKAI',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/10b700dd-1018-4500-8460-618f72424181',
            width: 1080,
            height: 1080,
        },
        wikis: ['2169014', '3021257'],
    },
    {
        id: '438',
        name: 'Hazbin Hotel',
        color: '#411716',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f960ae52-8813-42ca-a15b-61943f87b96e',
            width: 1600,
            height: 1024,
        },
        wikis: ['1589971', '1838119'],
    },
    {
        id: '439',
        name: 'Dune',
        color: '#a6c9b5',
        image: {
            url: 'https://vignette.wikia.nocookie.net/941e8770-501e-4636-8056-d4eb5221dd6b',
            width: 1600,
            height: 1024,
        },
        wikis: ['642', '271131'],
    },
    {
        id: '318',
        name: 'The Expanse',
        color: '#091d3b',
        image: {
            url: 'https://vignette.wikia.nocookie.net/2854b2b1-c379-4450-97ae-1d4eccb418fd',
            width: 1600,
            height: 1024,
        },
        wikis: ['783468'],
    },
    {
        id: '319',
        name: 'Viva Piñata',
        color: '#f9e438',
        image: {
            url: 'https://vignette.wikia.nocookie.net/9cf230b6-319a-435b-ac11-4e5580b346b6',
            width: 1600,
            height: 1024,
        },
        wikis: ['4869'],
    },
    {
        id: '680',
        name: 'Emergency Response: Lib. C.',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e56c670c-216e-4d8b-b4b7-8bdbb25f3f54',
            width: 988,
            height: 932,
        },
        wikis: ['1909054'],
    },
    {
        id: '681',
        name: 'Sky: Children of the Light',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c1125761-8355-46a4-acd7-e95b3ba2ec1e',
            width: 512,
            height: 512,
        },
        wikis: ['2010036', '2056687', '2068850', '2079757', '2334594', '2351755', '2628896'],
    },
    {
        id: '560',
        name: 'Dota 2',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/0e8933a9-1f18-4335-987b-ab9b380b4dc1',
            width: 1080,
            height: 1080,
        },
        wikis: ['2293864', '2294591', '2294686'],
    },
    {
        id: '682',
        name: 'Barney',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/12dba087-38c8-4a52-861f-507ec7be7358',
            width: 560,
            height: 560,
        },
        wikis: ['9144'],
    },
    {
        id: '561',
        name: 'Grounded',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b24288df-704e-47ad-8a7a-22c59eb60410',
            width: 1080,
            height: 1080,
        },
        wikis: ['2120253', '2323656'],
    },
    {
        id: '440',
        name: 'BioShock',
        color: '#41736d',
        image: {
            url: 'https://vignette.wikia.nocookie.net/1bd9c273-06c2-4169-a5b5-4c091ad3ef6f',
            width: 1600,
            height: 1024,
        },
        wikis: ['3490', '28796', '41649', '77040', '405980'],
    },
    {
        id: '683',
        name: 'Total Drama',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/0848076b-40c1-4e58-b650-b0076b0fa84f',
            width: 914,
            height: 914,
        },
        wikis: ['7976', '25986', '155946', '157420'],
    },
    {
        id: '562',
        name: "Friday Night Funkin'",
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/32dbe16d-140c-48ad-af76-c1c3ef185546',
            width: 1080,
            height: 1080,
        },
        wikis: ['2395902', '2498467', '2499635', '2628125', '2656118', '2761264'],
    },
    {
        id: '320',
        name: 'Stargate',
        color: '#38a9bf',
        image: {
            url: 'https://vignette.wikia.nocookie.net/793eab69-a9d9-47ef-92a5-8a96115b1b90',
            width: 1600,
            height: 1024,
        },
        wikis: ['119'],
    },
    {
        id: '684',
        name: 'Honkai: Star Rail',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b50d5da9-569f-457d-9089-872db4befe04',
            width: 1080,
            height: 1080,
        },
        wikis: ['2803004', '2968885', '2969331', '2974863', '3132139', '3183877', '3194012'],
    },
    {
        id: '563',
        name: 'Shindo Life',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/183d9c3a-528d-43da-bb8b-37ab0bf21186',
            width: 1080,
            height: 1080,
        },
        wikis: ['2381124'],
    },
    {
        id: '442',
        name: 'Kipo',
        color: '#78cccf',
        image: {
            url: 'https://vignette.wikia.nocookie.net/32c217ea-2d99-4bba-908d-e1cd85e482e2',
            width: 1600,
            height: 1024,
        },
        wikis: ['2028880'],
    },
    {
        id: '321',
        name: 'Rec Room',
        color: '#fc9a27',
        image: {
            url: 'https://vignette.wikia.nocookie.net/0eed2040-5da7-4426-adde-c29fd03a1ca4',
            width: 1600,
            height: 1024,
        },
        wikis: ['1562324'],
    },
    {
        id: '200',
        name: 'Kancolle',
        color: '#87125a',
        image: {
            url: 'https://vignette.wikia.nocookie.net/736c3f92-0779-44f7-957a-c6a012c8cfba',
            width: 1600,
            height: 1024,
        },
        wikis: ['813333', '848428'],
    },
    {
        id: '685',
        name: 'Phasmophobia',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/d975fdf3-9e60-4ccf-9cd7-a28091d741f1',
            width: 1080,
            height: 1080,
        },
        wikis: ['2376699', '2399376', '2402501', '2404427'],
    },
    {
        id: '564',
        name: 'Conan Exiles',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/6b13e4fc-2fdd-436d-86a9-5b3f4201aa78',
            width: 1080,
            height: 1080,
        },
        wikis: ['2293423', '2293657', '2293942', '2294401', '2295080', '2295094'],
    },
    {
        id: '443',
        name: 'American Idol',
        color: '#3c4676',
        image: {
            url: 'https://vignette.wikia.nocookie.net/8ee2153a-2542-4370-984c-8f64f0a34c69',
            width: 1600,
            height: 1024,
        },
        wikis: ['13469'],
    },
    {
        id: '322',
        name: 'Beyblade',
        color: '#1c8cc3',
        image: {
            url: 'https://vignette.wikia.nocookie.net/6c62fcf7-9221-440a-9164-b045154bb8f7',
            width: 1600,
            height: 1024,
        },
        wikis: ['3655', '46504'],
    },
    {
        id: '201',
        name: 'The Amazing World of Gumball',
        color: '#e20f91',
        image: {
            url: 'https://vignette.wikia.nocookie.net/0e704ca9-6506-4e54-9380-7823f91211c0',
            width: 1600,
            height: 1024,
        },
        wikis: ['245424', '275585', '413668', '475201', '558892', '616171'],
    },
    {
        id: '686',
        name: 'Barbie',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/47bf6f6a-01db-45d2-aae6-778b2e92c59a',
            width: 1080,
            height: 1080,
        },
        wikis: ['6028'],
    },
    {
        id: '565',
        name: 'Bee Swarm Simulator',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/db9b467b-633e-4c37-9bdf-902c826a241e',
            width: 1080,
            height: 1080,
        },
        wikis: ['1710458', '1740381'],
    },
    {
        id: '444',
        name: 'EastEnders',
        color: '#b99cac',
        image: {
            url: 'https://vignette.wikia.nocookie.net/6eeea870-4f07-4955-909f-fc891d9c04e7',
            width: 1600,
            height: 1024,
        },
        wikis: ['2334'],
    },
    {
        id: '323',
        name: 'Dresden Files',
        color: '#728696',
        image: {
            url: 'https://vignette.wikia.nocookie.net/94c3ec5b-a5c1-432d-950d-32aa94d5cd02',
            width: 1600,
            height: 1024,
        },
        wikis: ['6425'],
    },
    {
        id: '202',
        name: 'The Wiggles',
        color: '#f1d328',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b4658ea6-235c-49ec-af1d-7fc7a2bf655a',
            width: 1600,
            height: 1024,
        },
        wikis: ['3626'],
    },
    {
        id: '687',
        name: 'Rebel Moon',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e30a14ef-a2c5-4fed-936c-795ce71b67ef',
            width: 750,
            height: 750,
        },
        wikis: ['2716823'],
    },
    {
        id: '566',
        name: 'Jujutsu Kaisen',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/0ef90b9e-7a3f-426f-a975-6c1982787b5c',
            width: 1080,
            height: 1080,
        },
        wikis: ['1738561', '2100969', '2175504', '2393577'],
    },
    {
        id: '445',
        name: 'Grandmaster of Demonic Cultivation',
        color: '#455d75',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b22cdcd4-9eca-435f-a47d-2ade75aa1135',
            width: 1600,
            height: 1024,
        },
        wikis: ['1730925', '1937209'],
    },
    {
        id: '324',
        name: 'Forza',
        color: '#b2373c',
        image: {
            url: 'https://vignette.wikia.nocookie.net/bd67ab75-0d67-4b24-a0bc-a90bde4eb818',
            width: 1600,
            height: 1024,
        },
        wikis: ['8062'],
    },
    {
        id: '203',
        name: 'Mugen',
        color: '#e5d21f',
        image: {
            url: 'https://vignette.wikia.nocookie.net/d781db4a-c882-438b-9e48-5df434ee5cd9',
            width: 1600,
            height: 1024,
        },
        wikis: ['665', '644159'],
    },
    {
        id: '688',
        name: 'The Arcana',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/159d619f-1c0a-44a5-a544-3f935ce38719',
            width: 1080,
            height: 1080,
        },
        wikis: ['1545457'],
    },
    {
        id: '567',
        name: 'Path of Exile',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f31f6e71-2bff-49c5-a8ee-3789e942cfc2',
            width: 1080,
            height: 1080,
        },
        wikis: ['2293482', '2293496', '2293639', '2294824', '2295333'],
    },
    {
        id: '446',
        name: 'Age of Empires',
        color: '#155fff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/8c2a5d64-4a18-4d1d-aa83-c28809bcae90',
            width: 1600,
            height: 1024,
        },
        wikis: ['659', '6765', '947318', '1477385'],
    },
    {
        id: '325',
        name: 'Inheritance',
        color: '#f9ca58',
        image: {
            url: 'https://vignette.wikia.nocookie.net/2bdf4a64-b889-4149-94a9-0a950901b43f',
            width: 1600,
            height: 1024,
        },
        wikis: ['645', '7710', '66271'],
    },
    {
        id: '204',
        name: 'Outlander',
        color: '#a1d56a',
        image: {
            url: 'https://vignette.wikia.nocookie.net/0187a5c2-cd0b-4c3a-bc6b-3b7467fd7f55',
            width: 1600,
            height: 1024,
        },
        wikis: ['55705', '1175004'],
    },
    {
        id: '689',
        name: 'Neon Abyss',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/67da2cdd-6479-49db-b555-96725a4337dc',
            width: 1080,
            height: 1080,
        },
        wikis: ['2294502'],
    },
    {
        id: '568',
        name: 'MTG',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/6c9b356c-390c-414c-bf19-68fbbabb4174',
            width: 1080,
            height: 1080,
        },
        wikis: ['2294988'],
    },
    {
        id: '447',
        name: 'Locke and Key',
        color: '#764b48',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b84ce4a4-be66-44a8-a85b-1f98dc470ad4',
            width: 1600,
            height: 1024,
        },
        wikis: ['477171', '2143585'],
    },
    {
        id: '326',
        name: 'Pixel Gun',
        color: '#1fb1ec',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ff81ae73-9074-4899-b4e5-67bd13fbe1d7',
            width: 1600,
            height: 1024,
        },
        wikis: ['884361'],
    },
    {
        id: '205',
        name: 'Titanfall',
        color: '#4facc1',
        image: {
            url: 'https://vignette.wikia.nocookie.net/20268934-8867-4ac8-aff8-14e727fb5404',
            width: 1600,
            height: 1024,
        },
        wikis: ['764272'],
    },
    {
        id: '569',
        name: 'Diablo',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/828e7480-6193-447d-a452-e75bb4d4bdb2',
            width: 1080,
            height: 1080,
        },
        wikis: ['255', '1820', '5202', '8023', '10609', '62174'],
    },
    {
        id: '448',
        name: 'Shipping',
        color: '#e91172',
        image: {
            url: 'https://vignette.wikia.nocookie.net/7a6902a4-8644-43e6-8f75-b0af6c6d3d77',
            width: 1600,
            height: 1024,
        },
        wikis: ['741891'],
    },
    {
        id: '327',
        name: 'Old School RuneScape',
        color: '#a0825c',
        image: {
            url: 'https://vignette.wikia.nocookie.net/87a7138a-6032-47c2-97c1-971cbe463612',
            width: 1600,
            height: 1024,
        },
        wikis: ['691244'],
    },
    {
        id: '206',
        name: 'Pretty Cure',
        color: '#e35be5',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ea7f6f3e-43e8-4db1-a290-97626914e4af',
            width: 1600,
            height: 1024,
        },
        wikis: ['12606', '116887', '166499', '508620', '512217', '840102'],
    },
    {
        id: '449',
        name: 'Metro',
        color: '#ff7400',
        image: {
            url: 'https://vignette.wikia.nocookie.net/2777728f-e569-44a7-89c5-aa603a10d8b3',
            width: 1600,
            height: 1024,
        },
        wikis: ['24101', '88105', '718213'],
    },
    {
        id: '328',
        name: 'Star Wars Resistance',
        color: '#55b8f5',
        image: {
            url: 'https://vignette.wikia.nocookie.net/bfd1d948-902d-42b6-bba0-abeb5edf6fb4',
            width: 1600,
            height: 1024,
        },
        wikis: ['1695487'],
    },
    {
        id: '207',
        name: 'Voltron',
        color: '#1d46a7',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c2ec5cd1-e6a9-4157-9e3c-e4f34bca7d1c',
            width: 1600,
            height: 1024,
        },
        wikis: ['10679'],
    },
    {
        id: '329',
        name: 'Archer',
        color: '#1f7fbd',
        image: {
            url: 'https://vignette.wikia.nocookie.net/8a59fafa-70a6-4b8e-97cf-693d4049c1fa',
            width: 1600,
            height: 1024,
        },
        wikis: ['91319'],
    },
    {
        id: '208',
        name: 'Logos',
        color: '#e3d027',
        image: {
            url: 'https://vignette.wikia.nocookie.net/dbee8b61-07a4-4d56-b924-93926db5a609',
            width: 1600,
            height: 1024,
        },
        wikis: ['31618'],
    },
    {
        id: '209',
        name: 'Battlefield',
        color: '#96b0b8',
        image: {
            url: 'https://vignette.wikia.nocookie.net/1d74258e-02c1-49f4-86d7-d4c06d562d38',
            width: 1600,
            height: 1024,
        },
        wikis: ['1139', '137054', '148136', '171566', '249962'],
    },
    {
        id: '690',
        name: 'Starfield',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/bc5b752d-baee-44e6-9b54-f98bd7c1bdc3',
            width: 1176,
            height: 1176,
        },
        wikis: ['1720506'],
    },
    {
        id: '691',
        name: 'Dungeons & Dragons',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/029c1863-658c-4fd9-b720-ebbf4e468113',
            width: 732,
            height: 732,
        },
        wikis: ['43611'],
    },
    {
        id: '570',
        name: 'Creatures of Sonaria',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/105546b1-f2e0-4260-a5fc-f471fa222463',
            width: 1080,
            height: 1080,
        },
        wikis: ['2308060'],
    },
    {
        id: '692',
        name: 'Disney Speedstorm',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/34635488-8404-4625-8033-58d7e838a28a',
            width: 1038,
            height: 1038,
        },
        wikis: ['3002416'],
    },
    {
        id: '571',
        name: 'Adopt Me',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f90dbf6e-6ffc-41ba-9a39-901e6615129f',
            width: 1080,
            height: 1080,
        },
        wikis: ['1619358'],
    },
    {
        id: '450',
        name: 'Lumber Tycoon 2',
        color: '#ee7e14',
        image: {
            url: 'https://vignette.wikia.nocookie.net/1eb5d968-37c1-4ac1-a0ce-29e8d73a0cec',
            width: 1600,
            height: 1024,
        },
        wikis: ['1258949'],
    },
    {
        id: '693',
        name: 'SCUM',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c03a8961-d648-47a8-9771-44915f9f9b73',
            width: 1080,
            height: 1080,
        },
        wikis: ['2294906'],
    },
    {
        id: '572',
        name: 'Avatar',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/14fbb5cb-3961-4843-8a60-1be76bf8dadf',
            width: 1080,
            height: 1080,
        },
        wikis: ['38188', '46527', '79339', '83530', '583921'],
    },
    {
        id: '451',
        name: 'Sex Education',
        color: '#f0c1d9',
        image: {
            url: 'https://vignette.wikia.nocookie.net/032d41ff-1429-46e0-913e-b0e04b2c17ee',
            width: 1600,
            height: 1024,
        },
        wikis: ['2064041'],
    },
    {
        id: '330',
        name: 'Glitchtale',
        color: '#e37ee3',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e2a0503d-39e7-46ba-b3c7-0396ff6f8196',
            width: 1600,
            height: 1024,
        },
        wikis: ['1429460', '1485900'],
    },
    {
        id: '694',
        name: 'Person of Interest',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/92364126-8828-4f2a-99aa-8af9e5a7a485',
            width: 1080,
            height: 1080,
        },
        wikis: ['361686'],
    },
    {
        id: '573',
        name: 'Kamen Rider',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/396d8c98-f172-45f0-9533-97a9be06e10a',
            width: 1080,
            height: 1080,
        },
        wikis: ['5975', '560614', '2363846'],
    },
    {
        id: '452',
        name: 'Altered Carbon',
        color: '#2b3b43',
        image: {
            url: 'https://vignette.wikia.nocookie.net/a3517bed-7e93-4687-8d9f-fcbf084b882e',
            width: 1600,
            height: 1024,
        },
        wikis: ['1659097'],
    },
    {
        id: '331',
        name: 'Last Day on Earth: Survival',
        color: '#708157',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ac15f4ac-097a-4013-8254-427f48eafeb5',
            width: 1600,
            height: 1024,
        },
        wikis: ['1577298', '1585310'],
    },
    {
        id: '210',
        name: 'Tower of Saviors',
        color: '#2aba81',
        image: {
            url: 'https://vignette.wikia.nocookie.net/6324a41b-cc7b-4381-b410-2197fd4d9501',
            width: 1600,
            height: 1024,
        },
        wikis: ['681646', '694795'],
    },
    {
        id: '695',
        name: 'Yaoi',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/dd2453ac-c26f-4945-b242-2a89e7e1300c',
            width: 837,
            height: 837,
        },
        wikis: ['77775'],
    },
    {
        id: '574',
        name: 'Blue Lock',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/af7e7d34-1f4d-4fa5-be17-01570438f869',
            width: 1080,
            height: 1080,
        },
        wikis: ['2035004'],
    },
    {
        id: '453',
        name: 'I Am Not Okay With This',
        color: '#fbff83',
        image: {
            url: 'https://vignette.wikia.nocookie.net/0e94bbb1-e3c5-4f27-9c29-2390b40aefb8',
            width: 1600,
            height: 1024,
        },
        wikis: ['1985063'],
    },
    {
        id: '332',
        name: 'Melanie Martinez',
        color: '#dd5f8e',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b79106ba-2057-4a5b-9044-41d1f7fe0b84',
            width: 1600,
            height: 1024,
        },
        wikis: ['1065217'],
    },
    {
        id: '211',
        name: 'Doom',
        color: '#ce4726',
        image: {
            url: 'https://vignette.wikia.nocookie.net/d424e579-bd59-412f-859c-b1fb323761cc',
            width: 1600,
            height: 1024,
        },
        wikis: ['51', '2304', '1077187'],
    },
    {
        id: '696',
        name: 'Deltarune',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/942e4f18-e15d-4644-8a86-8c3bdc18c7d8',
            width: 1080,
            height: 1080,
        },
        wikis: ['1849073'],
    },
    {
        id: '575',
        name: 'Hunterpedia',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/77c69c32-2345-4bb7-8b95-489edf06118c',
            width: 1080,
            height: 1080,
        },
        wikis: ['6527', '13163', '77130', '90819', '345416', '386145', '1004281', '1281100'],
    },
    {
        id: '454',
        name: 'Blackish',
        color: '#ffa67d',
        image: {
            url: 'https://vignette.wikia.nocookie.net/fc01ac4a-37a0-4fdd-a163-b8e15dc9e091',
            width: 1600,
            height: 1024,
        },
        wikis: ['976177'],
    },
    {
        id: '333',
        name: 'Pixel Worlds',
        color: '#1fb1ec',
        image: {
            url: 'https://vignette.wikia.nocookie.net/43957dc5-635a-42d8-8adf-920aaf364af2',
            width: 1600,
            height: 1024,
        },
        wikis: ['1423520'],
    },
    {
        id: '212',
        name: 'Taylor Swift',
        color: '#fe5940',
        image: {
            url: 'https://vignette.wikia.nocookie.net/851bfec4-0b48-4dc8-b3eb-ca7a122d401c',
            width: 1600,
            height: 1024,
        },
        wikis: ['73934'],
    },
    {
        id: '697',
        name: 'Invincible',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/0a4ea88f-6605-4173-92ce-744579a8442d',
            width: 920,
            height: 920,
        },
        wikis: ['2161874'],
    },
    {
        id: '576',
        name: 'Roblox',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b6a54bac-46df-4ad1-b5e6-ed88068fb9b1',
            width: 1080,
            height: 1080,
        },
        wikis: ['4396', '109010', '524729', '587319', '2891549', '3100738'],
    },
    {
        id: '455',
        name: 'The Goldbergs/Schooled',
        color: '#d8f1f9',
        image: {
            url: 'https://vignette.wikia.nocookie.net/0b07c0ee-26d5-4130-a12c-f6d281239bb2',
            width: 1600,
            height: 1024,
        },
        wikis: ['586385'],
    },
    {
        id: '334',
        name: 'Poppy',
        color: '#dbb2be',
        image: {
            url: 'https://vignette.wikia.nocookie.net/0a391639-6ca5-4d16-aef9-6759c8516783',
            width: 1600,
            height: 1024,
        },
        wikis: ['1516676'],
    },
    {
        id: '213',
        name: 'XCOM',
        color: '#46abd7',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f34da7ca-3a03-4f49-ae97-abf2730d119d',
            width: 1600,
            height: 1024,
        },
        wikis: ['198492', '615066', '697742'],
    },
    {
        id: '698',
        name: 'Pizza Tower',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/770d64c0-db79-4f2b-a209-575419175b2f',
            width: 1800,
            height: 1800,
        },
        wikis: ['1829461'],
    },
    {
        id: '577',
        name: 'Cookie Run: Kingdom',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/db9f510f-7d23-4d5f-a1a6-f82e31484a1d',
            width: 1080,
            height: 1080,
        },
        wikis: ['2496071', '2848790'],
    },
    {
        id: '456',
        name: 'American Housewife',
        color: '#bbbbff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/913719a6-ea72-4d2e-b7aa-15aecf485c18',
            width: 1600,
            height: 1024,
        },
        wikis: ['1401921'],
    },
    {
        id: '335',
        name: 'Parks and Recreation',
        color: '#0f9a67',
        image: {
            url: 'https://vignette.wikia.nocookie.net/cab1a58b-290a-4345-9d8e-cacf17156103',
            width: 1600,
            height: 1024,
        },
        wikis: ['14448'],
    },
    {
        id: '214',
        name: 'LEGO',
        color: '#cc1616',
        image: {
            url: 'https://vignette.wikia.nocookie.net/d5aea96b-c6ce-45ef-8013-57c0a361f9b3',
            width: 1600,
            height: 1024,
        },
        wikis: ['984', '4481', '32226', '69900', '90464', '137466', '204853', '781270'],
    },
    {
        id: '578',
        name: 'Ensemble Stars',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/9931ee12-a62a-44e8-b2eb-ef58bd10be53',
            width: 1080,
            height: 1080,
        },
        wikis: ['1153146'],
    },
    {
        id: '457',
        name: 'Roswell',
        color: '#3f2931',
        image: {
            url: 'https://vignette.wikia.nocookie.net/a5581328-6917-4e8d-90b0-09ced0083f46',
            width: 1600,
            height: 1024,
        },
        wikis: ['4707'],
    },
    {
        id: '336',
        name: 'Umbrella Academy',
        color: '#e9bf4b',
        image: {
            url: 'https://vignette.wikia.nocookie.net/cd030c9f-efae-46f7-80d0-b0fb755f8508',
            width: 1600,
            height: 1024,
        },
        wikis: ['116808'],
    },
    {
        id: '215',
        name: 'The Fast and the Furious',
        color: '#dc8f00',
        image: {
            url: 'https://vignette.wikia.nocookie.net/6ce62e71-81f2-4669-9b45-5de9e815df1c',
            width: 1600,
            height: 1024,
        },
        wikis: ['4919', '557216', '639252'],
    },
    {
        id: '579',
        name: 'Your Bizarre Adventure',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/0f8aa95c-8e6d-4e5c-a7bf-6416a3625951',
            width: 1080,
            height: 1080,
        },
        wikis: ['2129399'],
    },
    {
        id: '458',
        name: 'Siren',
        color: '#024358',
        image: {
            url: 'https://vignette.wikia.nocookie.net/8de75f1c-6ff3-4ec1-ae13-7fa062914317',
            width: 1600,
            height: 1024,
        },
        wikis: ['285527'],
    },
    {
        id: '337',
        name: 'Hitman',
        color: '#c8ced6',
        image: {
            url: 'https://vignette.wikia.nocookie.net/34e6a4ae-0e0f-448a-bc19-6d7827abafab',
            width: 1600,
            height: 1024,
        },
        wikis: ['1057', '42627', '51201', '361641'],
    },
    {
        id: '216',
        name: 'Hearthstone',
        color: '#93691c',
        image: {
            url: 'https://vignette.wikia.nocookie.net/41732a77-ef6e-4930-b672-e2339167c2fb',
            width: 1600,
            height: 1024,
        },
        wikis: ['719313', '863997', '1103385', '2294428'],
    },
    {
        id: '459',
        name: 'The Good Doctor',
        color: '#90cbd4',
        image: {
            url: 'https://vignette.wikia.nocookie.net/da5655d5-d089-41d7-8b2c-2e449091dd7a',
            width: 1600,
            height: 1024,
        },
        wikis: ['1587667'],
    },
    {
        id: '338',
        name: 'Hay Day',
        color: '#4FAB4D',
        image: {
            url: 'https://vignette.wikia.nocookie.net/5edfb779-3ec8-453a-afb8-0151936f7d08',
            width: 1600,
            height: 1024,
        },
        wikis: ['558705', '569329', '1000810'],
    },
    {
        id: '217',
        name: 'SpongeBob',
        color: '#10a5c2',
        image: {
            url: 'https://vignette.wikia.nocookie.net/7ef839bf-4098-4225-93c3-608f6940c688',
            width: 1600,
            height: 1024,
        },
        wikis: ['2860', '11809', '103649', '232864', '391318', '996276'],
    },
    {
        id: '339',
        name: 'His Dark Materials',
        color: '#BCF1EA',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ff56142d-4408-41fc-bb0f-9024a64b4408',
            width: 1600,
            height: 1024,
        },
        wikis: ['1339', '555312', '966164', '1167042'],
    },
    {
        id: '218',
        name: 'Diep.io',
        color: '#edeb5c',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f252c0e8-f287-4edd-8c54-0e6aa2e46954',
            width: 1600,
            height: 1024,
        },
        wikis: ['1399015', '1400253', '1403884', '1407074'],
    },
    {
        id: '219',
        name: 'The Beatles',
        color: '#e4c40f',
        image: {
            url: 'https://vignette.wikia.nocookie.net/30fdc2ed-cff0-41fb-ae28-36e618d3c10d',
            width: 1600,
            height: 1024,
        },
        wikis: ['2045', '49582'],
    },
    {
        id: '580',
        name: 'Stardew Valley',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ef1a8648-d037-490d-b273-d67788640974',
            width: 1080,
            height: 1080,
        },
        wikis: ['620348', '1363302', '1365085', '1367599'],
    },
    {
        id: '581',
        name: 'Outward',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/a7a2e584-2910-4f24-ba7b-39390184558d',
            width: 1080,
            height: 1080,
        },
        wikis: ['2294082'],
    },
    {
        id: '460',
        name: 'Elite',
        color: '#dd9a94',
        image: {
            url: 'https://vignette.wikia.nocookie.net/8e0898a6-2c5f-43b0-9b60-64eaca25d452',
            width: 1600,
            height: 1024,
        },
        wikis: ['1835967'],
    },
    {
        id: '582',
        name: 'FFXIclopedia',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/40480c16-587e-4d0f-9a94-f20690cdbaad',
            width: 1080,
            height: 1080,
        },
        wikis: ['1657'],
    },
    {
        id: '461',
        name: 'Archero',
        color: '#dfbf76',
        image: {
            url: 'https://vignette.wikia.nocookie.net/3e4e3793-24c8-47aa-b166-1e372ecf810b',
            width: 1600,
            height: 1024,
        },
        wikis: ['1992497'],
    },
    {
        id: '340',
        name: "JoJo's Bizarre Adventure",
        color: '#000000',
        image: {
            url: 'https://vignette.wikia.nocookie.net/25b38518-212c-4f26-abc5-e1f05f8408e3',
            width: 1600,
            height: 1024,
        },
        wikis: ['5278', '202355', '1421044'],
    },
    {
        id: '583',
        name: 'Dragon Adventures',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/324d00d1-d612-4a17-98c4-37314f7b5544',
            width: 1080,
            height: 1080,
        },
        wikis: ['2051849'],
    },
    {
        id: '462',
        name: 'Motherland: Fort Salem',
        color: '#1d5a89',
        image: {
            url: 'https://vignette.wikia.nocookie.net/9dd1d22e-0aa8-4421-801c-579a1a9cb11a',
            width: 1600,
            height: 1024,
        },
        wikis: ['2066345'],
    },
    {
        id: '341',
        name: 'Lost',
        color: '#7D9D80',
        image: {
            url: 'https://vignette.wikia.nocookie.net/4ca9d6d5-0d33-4e34-9f03-192872ef8d2f',
            width: 1600,
            height: 1024,
        },
        wikis: ['1574', '1704', '2481', '3555', '11432', '11433', '11434', '11437'],
    },
    {
        id: '220',
        name: 'Pirates of the Caribbean',
        color: '#b58244',
        image: {
            url: 'https://vignette.wikia.nocookie.net/44b56746-08d7-426f-a621-8b437c503cbb',
            width: 1080,
            height: 1080,
        },
        wikis: ['1668', '18298', '234730', '289635', '294998', '761952'],
    },
    {
        id: '584',
        name: 'Doors Game',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/426eb1a0-e3e3-4a59-bc27-6a7fa5fef09c',
            width: 1080,
            height: 1080,
        },
        wikis: ['3019914', '3035326', '3083514', '3117659'],
    },
    {
        id: '463',
        name: 'Trolls',
        color: '#c0eeb7',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b0d8f921-20bb-42db-a4af-d4def5419bd3',
            width: 1600,
            height: 1024,
        },
        wikis: ['1416669'],
    },
    {
        id: '342',
        name: 'One-Punch Man',
        color: '#6DC4E1',
        image: {
            url: 'https://vignette.wikia.nocookie.net/06931713-6159-4402-99c0-b820fd7cadcf',
            width: 1600,
            height: 1024,
        },
        wikis: ['633820', '1074601', '1168839', '1330157', '1351492', '1609744'],
    },
    {
        id: '221',
        name: 'Tibia',
        color: '#7e1baf',
        image: {
            url: 'https://vignette.wikia.nocookie.net/085f0d00-fb19-4941-b26e-cd4d0655f8ef',
            width: 1600,
            height: 1024,
        },
        wikis: ['351', '5072', '5094'],
    },
    {
        id: '100',
        name: 'Horizon Zero Dawn',
        color: '#7397a6',
        image: {
            url: 'https://vignette.wikia.nocookie.net/0fc81524-a771-4024-893c-7492f97c4eda',
            width: 1600,
            height: 1024,
        },
        wikis: ['1209305', '1307232', '1416683', '1538439'],
    },
    {
        id: '585',
        name: 'The Owl House',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c6e7ec2a-8930-4b8f-a580-5939e3df93ae',
            width: 1080,
            height: 1080,
        },
        wikis: ['1695622', '1706704', '2088495', '2171247'],
    },
    {
        id: '464',
        name: 'The Rookie',
        color: '#aed8ec',
        image: {
            url: 'https://vignette.wikia.nocookie.net/42bc0bf5-c92f-454c-a2cb-79f80c2e5b14',
            width: 1600,
            height: 1024,
        },
        wikis: ['1774019'],
    },
    {
        id: '343',
        name: 'The Office',
        color: '#58A1CF',
        image: {
            url: 'https://vignette.wikia.nocookie.net/85a6af44-897e-47ed-9a78-79abac49acd8',
            width: 1600,
            height: 1024,
        },
        wikis: ['1573'],
    },
    {
        id: '222',
        name: 'Dragon Story',
        color: '#cb1414',
        image: {
            url: 'https://vignette.wikia.nocookie.net/1f21aa00-a615-4fe2-ad11-6ef19a2af88a',
            width: 1600,
            height: 1024,
        },
        wikis: ['536811', '1156793'],
    },
    {
        id: '101',
        name: 'The Sims',
        color: '#25a2dd',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f9f94847-5d1b-46fe-a5d2-17d4a493f314',
            width: 1600,
            height: 1024,
        },
        wikis: ['105', '1432', '6013', '7051', '8035', '17108', '21010'],
    },
    {
        id: '586',
        name: 'Graveyard Keeper',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/51ba1218-1b32-4b88-a3b2-f0cd97b86bb4',
            width: 1080,
            height: 1080,
        },
        wikis: ['2293365', '2293855', '2294061', '2294543', '2294733'],
    },
    {
        id: '465',
        name: 'Devil May Cry',
        color: '#3da1b4',
        image: {
            url: 'https://vignette.wikia.nocookie.net/769127bb-17fa-46e9-82c2-69e052ac8da6',
            width: 1600,
            height: 1024,
        },
        wikis: ['1425', '7547', '568010'],
    },
    {
        id: '344',
        name: '24',
        color: '#839EA4',
        image: {
            url: 'https://vignette.wikia.nocookie.net/5cc7c914-fe56-415a-83d1-8f47cee1682d',
            width: 1600,
            height: 1024,
        },
        wikis: ['684'],
    },
    {
        id: '223',
        name: 'Regular Show',
        color: '#a5c15f',
        image: {
            url: 'https://vignette.wikia.nocookie.net/6eecc4ac-d446-4201-82be-3d4e94e45745',
            width: 1600,
            height: 1024,
        },
        wikis: ['79848', '367198', '394229'],
    },
    {
        id: '102',
        name: 'Dragon Age',
        color: '#c3cbc3',
        image: {
            url: 'https://vignette.wikia.nocookie.net/af8c9121-436e-49e8-9396-5f66b621160f',
            width: 1600,
            height: 1024,
        },
        wikis: ['10150', '14016', '24661', '68154', '68873', '76670', '111890', '485174'],
    },
    {
        id: '587',
        name: 'Arknights',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/80eac1ed-cbd9-4569-af0f-54a707daa52f',
            width: 1080,
            height: 1080,
        },
        wikis: ['2001122'],
    },
    {
        id: '466',
        name: 'The Division',
        color: '#e0b13f',
        image: {
            url: 'https://vignette.wikia.nocookie.net/2a070878-50ba-44b9-972c-0b210928f2bd',
            width: 1600,
            height: 1024,
        },
        wikis: ['767915', '942740'],
    },
    {
        id: '345',
        name: 'The Challenge',
        color: '#4ED3C8',
        image: {
            url: 'https://vignette.wikia.nocookie.net/cb794ab6-c2c1-47ee-a078-dd82fce0be49',
            width: 1600,
            height: 1024,
        },
        wikis: ['1121468'],
    },
    {
        id: '224',
        name: 'Orange is the New Black',
        color: '#0b69a0',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ac9fcfd3-5972-44c1-9bc4-79501348692d',
            width: 1600,
            height: 1024,
        },
        wikis: ['740935', '1020089', '1042259', '1133837'],
    },
    {
        id: '103',
        name: 'Mass Effect',
        color: '#10439b',
        image: {
            url: 'https://vignette.wikia.nocookie.net/1c52588d-7e3b-4d5c-9c75-a19ec1c2b8a7',
            width: 1600,
            height: 1024,
        },
        wikis: ['3491', '7317', '9768', '74103', '85434', '99874', '504275'],
    },
    {
        id: '588',
        name: 'Doodle World',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/2c6315fc-0cf5-4430-a1c0-d03c91e6f553',
            width: 1080,
            height: 1080,
        },
        wikis: ['2952363'],
    },
    {
        id: '467',
        name: 'Stargirl',
        color: '#124181',
        image: {
            url: 'https://vignette.wikia.nocookie.net/3bef0b73-53e6-44f5-b039-70f87d16c380',
            width: 1600,
            height: 1024,
        },
        wikis: ['1772083'],
    },
    {
        id: '346',
        name: 'The Man in the High Castle',
        color: '#9E3030',
        image: {
            url: 'https://vignette.wikia.nocookie.net/349982d0-92fa-42e3-a564-f9956323d781',
            width: 1600,
            height: 1024,
        },
        wikis: ['1229499', '1533206'],
    },
    {
        id: '225',
        name: 'Degrassi',
        color: '#1486a9',
        image: {
            url: 'https://vignette.wikia.nocookie.net/86058467-2324-4fda-8ac0-6c9476d3be72',
            width: 1600,
            height: 1024,
        },
        wikis: ['2111'],
    },
    {
        id: '104',
        name: 'Dying Light',
        color: '#d15926',
        image: {
            url: 'https://vignette.wikia.nocookie.net/21cc3275-199c-4a26-aca5-b72511a0f5f9',
            width: 1600,
            height: 1024,
        },
        wikis: ['765031', '811394', '1106674', '1122478'],
    },
    {
        id: '589',
        name: 'Loomian Legacy',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/6b3c4d09-1123-4140-b7c0-295d297fa9fa',
            width: 1080,
            height: 1080,
        },
        wikis: ['1908607'],
    },
    {
        id: '347',
        name: 'Black Mirror',
        color: '#667D82',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b5fcd4b9-b9df-4342-810f-1454533fa3ec',
            width: 1600,
            height: 1024,
        },
        wikis: ['1385371'],
    },
    {
        id: '226',
        name: 'Cars',
        color: '#f8b800',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ceacb2fe-8f01-4aef-bced-44408f17fcbb',
            width: 1600,
            height: 1024,
        },
        wikis: ['83275'],
    },
    {
        id: '105',
        name: 'Lord of the Rings',
        color: '#83915e',
        image: {
            url: 'https://vignette.wikia.nocookie.net/5a0d60a3-e72a-41fd-8be9-eeedb4c2c343',
            width: 1600,
            height: 1024,
        },
        wikis: ['159', '1910', '2654', '3066', '5858', '38924', '226474'],
    },
    {
        id: '469',
        name: "Everything's Gonna Be Okay",
        color: '#e4d8ad',
        image: {
            url: 'https://vignette.wikia.nocookie.net/86ae8054-50b7-475a-8c1e-71db4d75c4c2',
            width: 1600,
            height: 1024,
        },
        wikis: ['2150961'],
    },
    {
        id: '348',
        name: 'Full House',
        color: '#EEC951',
        image: {
            url: 'https://vignette.wikia.nocookie.net/7850a882-2b66-4fe4-aadf-8bb85bd1fc50',
            width: 1600,
            height: 1024,
        },
        wikis: ['460'],
    },
    {
        id: '227',
        name: 'Just Cause',
        color: '#71b5e3',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c6ad788d-5d8d-4a99-a040-6b96a07688c8',
            width: 1600,
            height: 1024,
        },
        wikis: ['4907'],
    },
    {
        id: '106',
        name: 'Teen Wolf',
        color: '#22241f',
        image: {
            url: 'https://vignette.wikia.nocookie.net/daa68708-d828-40ca-b409-9700d5399eff',
            width: 1600,
            height: 1024,
        },
        wikis: ['260936', '296530', '351441', '414679', '831793', '1133259'],
    },
    {
        id: '349',
        name: 'Good Omens',
        color: '#96BCC0',
        image: {
            url: 'https://vignette.wikia.nocookie.net/9a8817be-5541-4f72-824a-f479a22c00b9',
            width: 1600,
            height: 1024,
        },
        wikis: ['1623600'],
    },
    {
        id: '228',
        name: 'Terra Battle',
        color: '#d43b97',
        image: {
            url: 'https://vignette.wikia.nocookie.net/d17dc00d-a65b-4a01-bc11-03aa21302a7d',
            width: 1600,
            height: 1024,
        },
        wikis: ['1016456', '1043693'],
    },
    {
        id: '107',
        name: 'Creepy Pasta',
        color: '#9b1212',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ae26d157-ed49-4780-b138-0a6a51538fca',
            width: 1600,
            height: 1024,
        },
        wikis: ['147413', '211134', '446508', '476913', '537616', '565418'],
    },
    {
        id: '229',
        name: 'Ace Combat',
        color: '#6dbee9',
        image: {
            url: 'https://vignette.wikia.nocookie.net/5802f3b8-65e6-4c1e-929f-4aac24995d2c',
            width: 1600,
            height: 1024,
        },
        wikis: ['1903', '447496', '714805'],
    },
    {
        id: '108',
        name: 'Bloodborne',
        color: '#c4cacc',
        image: {
            url: 'https://vignette.wikia.nocookie.net/622ca4f1-cd28-41d2-b823-c19cbcd3fba7',
            width: 1600,
            height: 1024,
        },
        wikis: ['988689', '1053611', '1106624', '1139908'],
    },
    {
        id: '109',
        name: 'Borderlands',
        color: '#ffe23f',
        image: {
            url: 'https://vignette.wikia.nocookie.net/83ca1052-01a1-4404-8568-96df61c5eb9a',
            width: 1600,
            height: 1024,
        },
        wikis: ['11954', '63028', '80696', '105213', '110477', '674168'],
    },
    {
        id: '590',
        name: 'Tower Defense Simulator',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c671876e-0116-46aa-b201-abb2035fd4f7',
            width: 1080,
            height: 1080,
        },
        wikis: ['2015381'],
    },
    {
        id: '591',
        name: 'Ninjago',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/a6b6ebe6-05ae-44b3-93e2-17499ea1bbbd',
            width: 1080,
            height: 1080,
        },
        wikis: ['199889', '255221', '453446', '1215606'],
    },
    {
        id: '470',
        name: 'Mount and Blade',
        color: '#A1A1A1',
        image: {
            url: 'https://vignette.wikia.nocookie.net/26079dc4-c43b-4184-9609-b865ad1e704e',
            width: 1600,
            height: 1024,
        },
        wikis: ['7434', '739359', '903165'],
    },
    {
        id: '592',
        name: 'Law and Order',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/86e6595b-b903-42de-9152-cd8b7ba96e63',
            width: 1080,
            height: 1080,
        },
        wikis: ['312'],
    },
    {
        id: '350',
        name: 'Psycho-Pass',
        color: '#47B3B4',
        image: {
            url: 'https://vignette.wikia.nocookie.net/0aad0774-f783-41ce-9566-276d15b7b47d',
            width: 1600,
            height: 1024,
        },
        wikis: ['593916'],
    },
    {
        id: '593',
        name: 'Wings of Fire',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/938b689b-c831-4ee9-a0ca-ed82a0d67048',
            width: 1080,
            height: 1080,
        },
        wikis: ['571430', '885001', '1240949', '1338042'],
    },
    {
        id: '472',
        name: 'Nancy Drew',
        color: '#1c1a3c',
        image: {
            url: 'https://vignette.wikia.nocookie.net/534edc2a-4ac3-4bd2-ab65-b0753c3e81aa',
            width: 1600,
            height: 1024,
        },
        wikis: ['10157', '1363228'],
    },
    {
        id: '351',
        name: 'The Orville',
        color: '#E4E1CE',
        image: {
            url: 'https://vignette.wikia.nocookie.net/7a64521c-5978-4716-b943-cfc3d943ea32',
            width: 1600,
            height: 1024,
        },
        wikis: ['1572245'],
    },
    {
        id: '230',
        name: 'Uncharted',
        color: '#1c7182',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e4304e98-a375-4ccd-854d-79f7e800da53',
            width: 1600,
            height: 1024,
        },
        wikis: ['5481', '45825', '440511', '1127823'],
    },
    {
        id: '594',
        name: 'Merge Mansion',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c3ab10c4-9328-4c58-bb19-0b707232be52',
            width: 1080,
            height: 1080,
        },
        wikis: ['2409648'],
    },
    {
        id: '473',
        name: 'Half-Life',
        color: '#40636e',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e2226001-3f14-4b19-b135-7822fd2cf8b1',
            width: 1600,
            height: 1024,
        },
        wikis: ['795', '2992', '881770'],
    },
    {
        id: '352',
        name: 'Unbreakable Kimmy Schmidt',
        color: '#D9DF41',
        image: {
            url: 'https://vignette.wikia.nocookie.net/93509665-d557-4b0a-9a16-649dbf711658',
            width: 1600,
            height: 1024,
        },
        wikis: ['999129'],
    },
    {
        id: '231',
        name: 'Kirby',
        color: '#fff94d',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b1a9aea3-539f-48b1-b6bd-7f902598066e',
            width: 1600,
            height: 1024,
        },
        wikis: ['2254', '2728', '7918', '10183', '24892', '745773'],
    },
    {
        id: '110',
        name: 'Rainbow Six',
        color: '#596c73',
        image: {
            url: 'https://vignette.wikia.nocookie.net/a25a7a17-9994-4018-bb99-b1a44662411a',
            width: 1600,
            height: 1024,
        },
        wikis: ['2857', '991351', '1309138', '1344289'],
    },
    {
        id: '595',
        name: 'Black Clover',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ff612fe5-aa0c-4d90-83c1-37f4f528018e',
            width: 1080,
            height: 1080,
        },
        wikis: ['1123773', '1511104'],
    },
    {
        id: '474',
        name: 'Psych',
        color: '#d4ff71',
        image: {
            url: 'https://vignette.wikia.nocookie.net/8319fa84-d62e-47e7-850d-3214e863e496',
            width: 1600,
            height: 1024,
        },
        wikis: ['24662'],
    },
    {
        id: '353',
        name: 'Charmed',
        color: '#726c93',
        image: {
            url: 'https://vignette.wikia.nocookie.net/2de457a4-6f68-4b73-a6a5-3293dc7078bd',
            width: 1600,
            height: 1024,
        },
        wikis: ['977', '4435', '6536', '6756', '44270', '62474'],
    },
    {
        id: '232',
        name: 'Breaking Bad',
        color: '#0d6837',
        image: {
            url: 'https://vignette.wikia.nocookie.net/772f8f9f-a49b-4702-87ae-60f6fff9eb6d',
            width: 1600,
            height: 1024,
        },
        wikis: ['18733', '321986', '521005'],
    },
    {
        id: '111',
        name: 'Animal Crossing',
        color: '#89dbff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/df61ae75-e168-4769-9c6f-37049d59eaad',
            width: 1600,
            height: 1024,
        },
        wikis: ['583', '6221', '11289', '73495'],
    },
    {
        id: '596',
        name: 'Risk of Rain 2',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/972ec9c8-776c-43a1-911b-71a5c9e42b9f',
            width: 1080,
            height: 1080,
        },
        wikis: ['2295257'],
    },
    {
        id: '475',
        name: 'Kingdom',
        color: '#513555',
        image: {
            url: 'https://vignette.wikia.nocookie.net/87d89dbf-3b45-4f47-b745-64d957ed0178',
            width: 1600,
            height: 1024,
        },
        wikis: ['1034136'],
    },
    {
        id: '354',
        name: 'Dragon Quest',
        color: '#9bd1f3',
        image: {
            url: 'https://vignette.wikia.nocookie.net/09d66f11-6e2f-4f5e-b846-4055f618b57a',
            width: 1600,
            height: 1024,
        },
        wikis: ['2846', '115414', '135673', '166364', '226512'],
    },
    {
        id: '233',
        name: 'Soul Eater',
        color: '#982424',
        image: {
            url: 'https://vignette.wikia.nocookie.net/720aeba1-0960-4877-922f-63dac3294856',
            width: 1600,
            height: 1024,
        },
        wikis: ['8015', '15060'],
    },
    {
        id: '112',
        name: 'Watch Dogs',
        color: '#d90db4',
        image: {
            url: 'https://vignette.wikia.nocookie.net/2b0df3df-88bf-465e-9e77-d0120b912fd7',
            width: 1600,
            height: 1024,
        },
        wikis: ['577445', '580701', '702424', '778548', '793908', '955166', '984119'],
    },
    {
        id: '597',
        name: 'Virtual Youtuber',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/90711d33-75bd-42d7-9fae-14fd587a306c',
            width: 1080,
            height: 1080,
        },
        wikis: ['1654382', '1696899', '2389322', '2550592', '2602824', '3049406'],
    },
    {
        id: '476',
        name: 'Good Trouble',
        color: '#9eaed2',
        image: {
            url: 'https://vignette.wikia.nocookie.net/95acdd43-f2d9-4d85-8033-f70f62f8509a',
            width: 1600,
            height: 1024,
        },
        wikis: ['707903'],
    },
    {
        id: '355',
        name: 'Megaman',
        color: '#edd032',
        image: {
            url: 'https://vignette.wikia.nocookie.net/71f8a6b8-6968-42e9-a44d-cb2605c0a26c',
            width: 1600,
            height: 1024,
        },
        wikis: ['401', '1641', '19463'],
    },
    {
        id: '234',
        name: 'Lord of the Rings Minecraft',
        color: '#0e8f07',
        image: {
            url: 'https://vignette.wikia.nocookie.net/29bffa12-3ab0-40e5-927d-1700f4e29e3d',
            width: 1600,
            height: 1024,
        },
        wikis: ['997076', '1033966', '1072735'],
    },
    {
        id: '113',
        name: 'Battlefront',
        color: '#001055',
        image: {
            url: 'https://vignette.wikia.nocookie.net/0812f632-4ac4-4cd3-9604-4f726f9d2894',
            width: 1600,
            height: 1024,
        },
        wikis: ['2188'],
    },
    {
        id: '598',
        name: 'Murder Mystery 2',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/82b0c339-0f5c-4b94-8674-4b5c462d0d5d',
            width: 1080,
            height: 1080,
        },
        wikis: ['1113133'],
    },
    {
        id: '477',
        name: 'Young Justice',
        color: '#3a3a3a',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b99980d3-0a45-4685-8700-85e5902ebb41',
            width: 1600,
            height: 1024,
        },
        wikis: ['146012'],
    },
    {
        id: '356',
        name: 'Soul Calibur',
        color: '#a7a7d0',
        image: {
            url: 'https://vignette.wikia.nocookie.net/4754f940-908d-4583-a897-3f2764710d3d',
            width: 1600,
            height: 1024,
        },
        wikis: ['2965'],
    },
    {
        id: '235',
        name: 'Vintage Patterns',
        color: '#45d099',
        image: {
            url: 'https://vignette.wikia.nocookie.net/7acabd0c-efb0-45f3-bfec-7521344bd8e1',
            width: 1600,
            height: 1024,
        },
        wikis: ['4486'],
    },
    {
        id: '114',
        name: 'RuneScape',
        color: '#3a7dd5',
        image: {
            url: 'https://vignette.wikia.nocookie.net/5859feab-b5ba-4870-973b-8c91ef7b5223',
            width: 1600,
            height: 1024,
        },
        wikis: ['304', '855', '1923', '2497'],
    },
    {
        id: '599',
        name: 'NoPixel',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/51ca81f2-d7c8-420f-bf41-69d7061208bd',
            width: 1080,
            height: 1080,
        },
        wikis: ['1836623'],
    },
    {
        id: '478',
        name: 'The Bold Type',
        color: '#e56187',
        image: {
            url: 'https://vignette.wikia.nocookie.net/4ea96865-71fd-4637-9d4f-4fb884d90dd3',
            width: 1600,
            height: 1024,
        },
        wikis: ['1624210'],
    },
    {
        id: '357',
        name: 'Soul Knight',
        color: '#34c9f0',
        image: {
            url: 'https://vignette.wikia.nocookie.net/9e732ccc-4cd3-4fcd-a3f2-d2f91cd15712',
            width: 1600,
            height: 1024,
        },
        wikis: ['1523655', '1544302', '1773482'],
    },
    {
        id: '236',
        name: 'Evolve',
        color: '#fe3a1e',
        image: {
            url: 'https://vignette.wikia.nocookie.net/9430a610-c113-46e0-8f90-52d188d2e6e2',
            width: 1600,
            height: 1024,
        },
        wikis: ['898267', '961444', '988440'],
    },
    {
        id: '115',
        name: 'Attack on Titan',
        color: '#304832',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ae6c72db-6cc0-4d8a-af55-2c1257364b89',
            width: 1600,
            height: 1024,
        },
        wikis: ['338386', '620923', '753435', '792310', '820297', '851348', '1007329'],
    },
    {
        id: '479',
        name: 'Killing Eve',
        color: '#e05779',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ba9ed766-ecef-4156-9227-3f038ca687bb',
            width: 1600,
            height: 1024,
        },
        wikis: ['1708882'],
    },
    {
        id: '358',
        name: 'Throne of Glass',
        color: '#cfdee9',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b1860229-9346-4151-aabd-caa69097d9dd',
            width: 1600,
            height: 1024,
        },
        wikis: ['920930', '1534594'],
    },
    {
        id: '237',
        name: 'The Evil Within',
        color: '#588c78',
        image: {
            url: 'https://vignette.wikia.nocookie.net/732b4931-add9-44d6-ade6-ee708ff77bd8',
            width: 1600,
            height: 1024,
        },
        wikis: ['738140'],
    },
    {
        id: '116',
        name: 'Summoners War',
        color: '#4ec0da',
        image: {
            url: 'https://vignette.wikia.nocookie.net/79118134-2c8f-4cca-9aae-aa71f58bf644',
            width: 1600,
            height: 1024,
        },
        wikis: ['985887', '1041700'],
    },
    {
        id: '359',
        name: 'Vikings',
        color: '#b5b6b5',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b7bf906b-5741-4bd8-b7c9-80dab037f14f',
            width: 1600,
            height: 1024,
        },
        wikis: ['710900', '729444', '1119854'],
    },
    {
        id: '238',
        name: 'Yooka-Laylee',
        color: '#cd7dd9',
        image: {
            url: 'https://vignette.wikia.nocookie.net/4d2443be-90cb-42aa-b880-3154adaf3dcc',
            width: 1600,
            height: 1024,
        },
        wikis: ['1128918'],
    },
    {
        id: '117',
        name: 'Clash Royale',
        color: '#23c7e1',
        image: {
            url: 'https://vignette.wikia.nocookie.net/11caab68-7615-41cb-a62a-f8e2e59fa733',
            width: 1600,
            height: 1024,
        },
        wikis: ['1337445', '1337446', '1339385', '1344220', '1366651'],
    },
    {
        id: '239',
        name: 'Blood Brothers Game',
        color: '#575398',
        image: {
            url: 'https://vignette.wikia.nocookie.net/cac5de8b-32d3-4af7-ba30-9df6c9c9507e',
            width: 1600,
            height: 1024,
        },
        wikis: ['596376'],
    },
    {
        id: '118',
        name: 'Mortal Kombat',
        color: '#dc8813',
        image: {
            url: 'https://vignette.wikia.nocookie.net/9be0ddcd-c750-465d-93e8-39ca7f80ec53',
            width: 1600,
            height: 1024,
        },
        wikis: ['949', '4944', '11115', '151466', '289230'],
    },
    {
        id: '119',
        name: 'Crash Bandicoot',
        color: '#fff94c',
        image: {
            url: 'https://vignette.wikia.nocookie.net/2728ab7c-ca6c-4dbf-a423-b3ae6f55d81e',
            width: 1600,
            height: 1024,
        },
        wikis: ['749', '79306', '395414', '529583', '643116'],
    },
    {
        id: '11',
        name: 'Nintendo',
        color: '#e80318',
        image: {
            url: 'https://static.wikia.nocookie.net/b4c29200-ca21-4306-aa0c-c59330c7890d',
            width: 1600,
            height: 1024,
        },
        wikis: ['1242', '2627', '182688'],
    },
    {
        id: '14',
        name: 'Streaming',
        color: '#50538f',
        image: {
            url: 'https://static.wikia.nocookie.net/d2027d4a-6c8f-4d6d-84d4-bc3f330d4e45',
            width: 1600,
            height: 1024,
        },
        wikis: [],
    },
    {
        id: '15',
        name: 'Xbox',
        color: '#107b0f',
        image: {
            url: 'https://static.wikia.nocookie.net/93487b41-dbb9-4815-892b-ddb1d71b6e2a',
            width: 1600,
            height: 1024,
        },
        wikis: ['1490', '182688'],
    },
    {
        id: '16',
        name: 'PC Gaming',
        color: '#3b2941',
        image: {
            url: 'https://static.wikia.nocookie.net/88d19cc6-677e-4141-8781-c656b3ac8ae5',
            width: 1600,
            height: 1024,
        },
        wikis: ['1490', '182688'],
    },
    {
        id: '17',
        name: 'Game Reviews',
        color: '#dfec24',
        image: {
            url: 'https://static.wikia.nocookie.net/824c05c1-a4f7-4e0d-aecc-e5e66c5f50ff',
            width: 1600,
            height: 1024,
        },
        wikis: ['1490', '182688'],
    },
    {
        id: '18',
        name: 'Cosplay',
        color: '#00d6d3',
        image: {
            url: 'https://static.wikia.nocookie.net/81c57e8b-ff2f-4650-9f24-f366cc7033ce',
            width: 1600,
            height: 1024,
        },
        wikis: ['9738'],
    },
    {
        id: '19',
        name: 'TV Trailers',
        color: '#00634b',
        image: {
            url: 'https://static.wikia.nocookie.net/7c3eba96-ea8d-42e4-b8f3-eab8d4cb398a',
            width: 1600,
            height: 1024,
        },
        wikis: [],
    },
    {
        id: '480',
        name: 'Ori',
        color: '#f7f7c4',
        image: {
            url: 'https://vignette.wikia.nocookie.net/0f7fc6dd-db9c-435f-8b2c-ffec78382bb9',
            width: 1600,
            height: 1024,
        },
        wikis: ['988522'],
    },
    {
        id: '481',
        name: 'SNK',
        color: '#f7f7c4',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c5f6a6bb-29ce-4390-91b2-10b3c17985a3',
            width: 1600,
            height: 1024,
        },
        wikis: ['5748', '599607'],
    },
    {
        id: '360',
        name: 'Vocaloid',
        color: '#d8e6e6',
        image: {
            url: 'https://vignette.wikia.nocookie.net/9f6de77c-6179-4e22-9ba0-8f3b578373c9',
            width: 1600,
            height: 1024,
        },
        wikis: ['7857', '33304', '236567', '256707'],
    },
    {
        id: '482',
        name: 'Artemis Fowl',
        color: '#62cfbe',
        image: {
            url: 'https://vignette.wikia.nocookie.net/367a70f2-ba7e-457a-8ad0-1d5ca1507098',
            width: 1600,
            height: 1024,
        },
        wikis: ['379'],
    },
    {
        id: '361',
        name: 'Winx Club',
        color: '#24bdea',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ee2cf5ef-1139-4c28-8491-058bbed5373b',
            width: 1600,
            height: 1024,
        },
        wikis: ['6708', '86380'],
    },
    {
        id: '240',
        name: 'Baker Street',
        color: '#a0913a',
        image: {
            url: 'https://vignette.wikia.nocookie.net/eb089022-5c6b-4b74-bba7-5e2e25d5d61c',
            width: 1600,
            height: 1024,
        },
        wikis: ['23581', '91886', '681379', '1234209', '1234962', '1337804', '1407364'],
    },
    {
        id: '483',
        name: 'NOS4A2',
        color: '#513075',
        image: {
            url: 'https://vignette.wikia.nocookie.net/22c3835c-58c7-48e5-9c1b-a35ff5678fec',
            width: 1600,
            height: 1024,
        },
        wikis: ['1718728'],
    },
    {
        id: '362',
        name: 'Buffy and Angel',
        color: '#513955',
        image: {
            url: 'https://vignette.wikia.nocookie.net/d25b539a-f2e0-4f2e-a235-0b8f678f4cc5',
            width: 1600,
            height: 1024,
        },
        wikis: ['739', '11728', '41682', '79363'],
    },
    {
        id: '241',
        name: 'Scream Queens',
        color: '#980c3d',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b731a219-95cc-4b4b-9ece-0cb31a4a9f78',
            width: 1600,
            height: 1024,
        },
        wikis: ['1061981', '1372126'],
    },
    {
        id: '120',
        name: 'World of Warcraft',
        color: '#f2f950',
        image: {
            url: 'https://vignette.wikia.nocookie.net/a0386166-f7ff-4338-88c4-2352167dd160',
            width: 1600,
            height: 1024,
        },
        wikis: ['641', '2943', '3132', '3289', '2293457'],
    },
    {
        id: '484',
        name: 'Valorant',
        color: '#f5829f',
        image: {
            url: 'https://vignette.wikia.nocookie.net/6f8c0513-f836-4f4f-808a-d2d69477f285',
            width: 1600,
            height: 1024,
        },
        wikis: ['2175921', '2181404', '2187554'],
    },
    {
        id: '363',
        name: 'Choices: Stories You Play',
        color: '#a1ebfb',
        image: {
            url: 'https://vignette.wikia.nocookie.net/9af8dcf3-c3b9-461e-8558-df4ae31a7d03',
            width: 1600,
            height: 1024,
        },
        wikis: ['1447835'],
    },
    {
        id: '242',
        name: 'Shantae',
        color: '#29a8b6',
        image: {
            url: 'https://vignette.wikia.nocookie.net/84b2237f-5f05-43a2-872e-757c3138ea2b',
            width: 1600,
            height: 1024,
        },
        wikis: ['60471'],
    },
    {
        id: '121',
        name: 'Pretty Little Liars',
        color: '#7695b0',
        image: {
            url: 'https://vignette.wikia.nocookie.net/524d1484-1998-40f6-af7b-69f775663e83',
            width: 1600,
            height: 1024,
        },
        wikis: ['35322', '324983', '544777', '1425424'],
    },
    {
        id: '485',
        name: 'Octopath Traveler',
        color: '#fff9ba',
        image: {
            url: 'https://vignette.wikia.nocookie.net/1c13c53f-0b95-4683-8026-26d10bd906ba',
            width: 1600,
            height: 1024,
        },
        wikis: ['1516778'],
    },
    {
        id: '364',
        name: 'Divinity',
        color: '#829db6',
        image: {
            url: 'https://vignette.wikia.nocookie.net/8de98ed1-e7c5-4f5f-a60f-1d734b7917bc',
            width: 1600,
            height: 1024,
        },
        wikis: ['74562', '615689'],
    },
    {
        id: '243',
        name: 'PUBG',
        color: '#3c9fc6',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e86e5c05-7b5c-4f7a-a7d7-3e764c8a8568',
            width: 1600,
            height: 1024,
        },
        wikis: ['1554581', '1667282', '1783841'],
    },
    {
        id: '122',
        name: 'Warriors',
        color: '#52bc44',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e9bf3c75-90b7-48cb-8b1b-f7b15a13eaf7',
            width: 1600,
            height: 1024,
        },
        wikis: ['1714', '18962', '453462', '888961'],
    },
    {
        id: '365',
        name: 'Hollow Knight',
        color: '#3d495e',
        image: {
            url: 'https://vignette.wikia.nocookie.net/a5c7f35c-faf7-4e7d-a9f7-58ddec98ff15',
            width: 1600,
            height: 1024,
        },
        wikis: ['1537707', '1552836', '1581783', '1594805', '1603676'],
    },
    {
        id: '244',
        name: 'Valkyrie Crusade',
        color: '#3cc6c4',
        image: {
            url: 'https://vignette.wikia.nocookie.net/a63d4c21-9c25-4644-b43f-32c8d8dbf26c',
            width: 1600,
            height: 1024,
        },
        wikis: ['711765', '790213'],
    },
    {
        id: '123',
        name: 'For Honor',
        color: '#d1cba0',
        image: {
            url: 'https://vignette.wikia.nocookie.net/009f56a3-e0f1-48c5-bf9d-0208a55b6652',
            width: 1600,
            height: 1024,
        },
        wikis: ['1209200', '1460347', '1472152'],
    },
    {
        id: '366',
        name: 'Kingdom Hearts',
        color: '#acacac',
        image: {
            url: 'https://vignette.wikia.nocookie.net/37684401-4734-41e3-889d-019c0f0341c7',
            width: 1600,
            height: 1024,
        },
        wikis: ['1346', '4951', '12648', '28227'],
    },
    {
        id: '245',
        name: 'Dawn of War',
        color: '#32528e',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b3e11a28-8f76-4a13-8291-a0aae2805559',
            width: 1600,
            height: 1024,
        },
        wikis: ['1368', '25097', '887802'],
    },
    {
        id: '124',
        name: 'Bleach',
        color: '#223f8f',
        image: {
            url: 'https://vignette.wikia.nocookie.net/25787581-9fc0-4a0b-bd61-8a0d0ffcb380',
            width: 1600,
            height: 1024,
        },
        wikis: ['3747', '7718', '9053', '11922', '38475', '91286', '401001'],
    },
    {
        id: '488',
        name: 'Vampire: The Masquerade - Bloodlines',
        color: '#99a993',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b6142525-9ccb-499a-927c-aea7c514147d',
            width: 1600,
            height: 1024,
        },
        wikis: ['20732', '588344'],
    },
    {
        id: '367',
        name: 'The Last Remnant',
        color: '#9fc9c9',
        image: {
            url: 'https://vignette.wikia.nocookie.net/2443161f-7696-4317-a44c-f0ff9beb0257',
            width: 1600,
            height: 1024,
        },
        wikis: ['11424'],
    },
    {
        id: '246',
        name: 'Agents of Mayhem',
        color: '#cf5367',
        image: {
            url: 'https://vignette.wikia.nocookie.net/4f98a662-946e-47e1-b37f-df85e015914e',
            width: 1600,
            height: 1024,
        },
        wikis: ['102147', '1451076'],
    },
    {
        id: '125',
        name: 'Boom Beach',
        color: '#7eb6d2',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ad5c38f2-8889-46d9-bf1c-19b63adea906',
            width: 1600,
            height: 1024,
        },
        wikis: ['863607', '864211', '945927', '1030055'],
    },
    {
        id: '489',
        name: 'Mafia',
        color: '#e9c0ca',
        image: {
            url: 'https://vignette.wikia.nocookie.net/db1ba181-52b7-4176-ba43-31a02571abdc',
            width: 1600,
            height: 1024,
        },
        wikis: ['12264', '124063', '537126'],
    },
    {
        id: '247',
        name: 'Westworld',
        color: '#b05622',
        image: {
            url: 'https://vignette.wikia.nocookie.net/33cd9af9-194a-4191-9335-510ef1a83e65',
            width: 1600,
            height: 1024,
        },
        wikis: ['1024023', '1419403', '1470032', '1473886', '1486213'],
    },
    {
        id: '126',
        name: 'Sword Art Online',
        color: '#33b6bb',
        image: {
            url: 'https://vignette.wikia.nocookie.net/0367fb3f-ac58-43ec-8e33-f364a9dffe18',
            width: 1600,
            height: 1024,
        },
        wikis: ['295658', '580809', '595955', '610674', '623112', '648356', '651254'],
    },
    {
        id: '248',
        name: 'Knights and Dragons',
        color: '#19ad6c',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c5864b20-203b-414b-87b3-dbc9bcd61a03',
            width: 1600,
            height: 1024,
        },
        wikis: ['742882'],
    },
    {
        id: '127',
        name: 'Dinosaurs',
        color: '#25943b',
        image: {
            url: 'https://vignette.wikia.nocookie.net/11a56022-e17e-4f1e-9686-39cec3c89ba5',
            width: 1600,
            height: 1024,
        },
        wikis: ['1898', '468470', '568109', '861152'],
    },
    {
        id: '249',
        name: 'Warcommander',
        color: '#c31515',
        image: {
            url: 'https://vignette.wikia.nocookie.net/9c590722-27d9-4cc2-bc74-f5cda0c2c66b',
            width: 1600,
            height: 1024,
        },
        wikis: ['360967'],
    },
    {
        id: '128',
        name: 'Hot Wheels',
        color: '#0d6bdd',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f6868bcf-c246-4306-a427-22c33272c10b',
            width: 1600,
            height: 1024,
        },
        wikis: ['2973'],
    },
    {
        id: '129',
        name: 'Payday',
        color: '#c93232',
        image: {
            url: 'https://vignette.wikia.nocookie.net/605cad26-83a2-4b6b-890a-ab9ef75464ae',
            width: 1600,
            height: 1024,
        },
        wikis: ['361803', '648919'],
    },
    {
        id: '20',
        name: 'Comic-Con',
        color: '#ffff00',
        image: {
            url: 'https://static.wikia.nocookie.net/78b2fede-2d71-4979-9e2a-affe1d621846',
            width: 1600,
            height: 1024,
        },
        wikis: [],
    },
    {
        id: '22',
        name: 'Movies',
        color: '#ff6a64',
        image: {
            url: 'https://static.wikia.nocookie.net/7330a3ba-d808-4827-be0f-df86242f387f',
            width: 1600,
            height: 1024,
        },
        wikis: ['2595', '423083'],
    },
    {
        id: '23',
        name: 'Movie Trailers',
        color: '#576702',
        image: {
            url: 'https://static.wikia.nocookie.net/51a896f1-e934-4820-a30a-6e5c4130d5f3',
            width: 1600,
            height: 1024,
        },
        wikis: [],
    },
    {
        id: '24',
        name: 'Playstation',
        color: '#004099',
        image: {
            url: 'https://static.wikia.nocookie.net/4ca33269-814a-406a-8c62-08b83f1f85a9',
            width: 1600,
            height: 1024,
        },
        wikis: ['1490', '182688'],
    },
    {
        id: '25',
        name: 'The CW',
        color: '#282a12',
        image: {
            url: 'https://static.wikia.nocookie.net/3fe95190-64bf-42d9-b339-e0fc835c4033',
            width: 1600,
            height: 1024,
        },
        wikis: [],
    },
    {
        id: '26',
        name: 'Movie Reviews',
        color: '#fccc27',
        image: {
            url: 'https://static.wikia.nocookie.net/83247198-b607-4f3b-9aa4-1ba683267ea9',
            width: 1600,
            height: 1024,
        },
        wikis: ['2595', '423083'],
    },
    {
        id: '28',
        name: 'Netflix',
        color: '#a72b23',
        image: {
            url: 'https://vignette.wikia.nocookie.net/23abb3d2-9a3a-467a-9112-f4363fa64c30',
            width: 1600,
            height: 1024,
        },
        wikis: ['288346', '2269657', '3213371'],
    },
    {
        id: '490',
        name: 'Command & Conquer',
        color: '#cee6e1',
        image: {
            url: 'https://vignette.wikia.nocookie.net/664fc028-0931-4ab7-915b-1e7ec3f68041',
            width: 1600,
            height: 1024,
        },
        wikis: ['896'],
    },
    {
        id: '491',
        name: 'Dark',
        color: '#241f37',
        image: {
            url: 'https://vignette.wikia.nocookie.net/5265e50e-7bab-427b-87c7-13e237f3ac4f',
            width: 1600,
            height: 1024,
        },
        wikis: ['1648094'],
    },
    {
        id: '370',
        name: 'Narcos',
        color: '#a4d8c8',
        image: {
            url: 'https://vignette.wikia.nocookie.net/9f69c5fb-100a-4d9e-9d6d-624d74d2b1dc',
            width: 1600,
            height: 1024,
        },
        wikis: ['1863040'],
    },
    {
        id: '492',
        name: 'Amphibia',
        color: '#1cb68e',
        image: {
            url: 'https://vignette.wikia.nocookie.net/82fd1315-17d1-40bc-989c-0ce528c282a6',
            width: 1600,
            height: 1024,
        },
        wikis: ['1988795', '2023615'],
    },
    {
        id: '371',
        name: 'Ozark',
        color: '#a3d5d8',
        image: {
            url: 'https://vignette.wikia.nocookie.net/3d29a36a-070e-4f0c-bde2-e4790a12ed7c',
            width: 1600,
            height: 1024,
        },
        wikis: ['2178596'],
    },
    {
        id: '250',
        name: 'The Kagerou Project',
        color: '#09a9a6',
        image: {
            url: 'https://vignette.wikia.nocookie.net/7c520e50-b5ea-4f8a-9ce0-5509715970f4',
            width: 1600,
            height: 1024,
        },
        wikis: ['574017', '606739', '863548'],
    },
    {
        id: '493',
        name: 'Snowpiercer',
        color: '#6b8397',
        image: {
            url: 'https://vignette.wikia.nocookie.net/8d2adb5e-5522-45e5-9676-a40208bcd602',
            width: 1600,
            height: 1024,
        },
        wikis: ['2037790'],
    },
    {
        id: '251',
        name: 'Sea of Thieves',
        color: '#2298b0',
        image: {
            url: 'https://vignette.wikia.nocookie.net/d6f2e3b6-47f1-4738-8d29-7b93ce0765b4',
            width: 1600,
            height: 1024,
        },
        wikis: ['1456372'],
    },
    {
        id: '130',
        name: 'Injustice',
        color: '#3f926c',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e6266703-99dd-45d1-9ec0-bc62dd33e5a5',
            width: 1600,
            height: 1024,
        },
        wikis: ['547034', '722213'],
    },
    {
        id: '494',
        name: 'Phineas and Ferb',
        color: '#35f3c9',
        image: {
            url: 'https://vignette.wikia.nocookie.net/dcd3186d-3816-4a12-af29-7f6875641057',
            width: 1600,
            height: 1024,
        },
        wikis: ['6390'],
    },
    {
        id: '373',
        name: 'S.W.A.T.',
        color: '#5791aa',
        image: {
            url: 'https://vignette.wikia.nocookie.net/42a371db-c098-48ea-a759-dd08730bb980',
            width: 1600,
            height: 1024,
        },
        wikis: ['1920978'],
    },
    {
        id: '252',
        name: 'Cameras',
        color: '#9030bc',
        image: {
            url: 'https://vignette.wikia.nocookie.net/9bc650ec-8788-4d73-a117-ae69b0be1443',
            width: 1600,
            height: 1024,
        },
        wikis: ['211208'],
    },
    {
        id: '131',
        name: 'Power Listing',
        color: '#4f68d9',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f9eb3768-f402-4a82-9004-5a14f72a9907',
            width: 1600,
            height: 1024,
        },
        wikis: ['48473'],
    },
    {
        id: '495',
        name: 'The West Wing',
        color: '#dbecb9',
        image: {
            url: 'https://vignette.wikia.nocookie.net/2cf10dd7-65fd-4d39-8a01-5633002c1f23',
            width: 1600,
            height: 1024,
        },
        wikis: ['775'],
    },
    {
        id: '374',
        name: 'The Haunting',
        color: '#8ca8ac',
        image: {
            url: 'https://vignette.wikia.nocookie.net/9df00ec3-ff90-497f-b61b-7fb2dc587ec4',
            width: 1600,
            height: 1024,
        },
        wikis: ['1842225'],
    },
    {
        id: '253',
        name: 'Whiskey',
        color: '#188894',
        image: {
            url: 'https://vignette.wikia.nocookie.net/4dcf9a55-bd97-4ebc-b4fd-ee17806addad',
            width: 1600,
            height: 1024,
        },
        wikis: ['443202'],
    },
    {
        id: '132',
        name: 'Metal Gear',
        color: '#ba0e0e',
        image: {
            url: 'https://vignette.wikia.nocookie.net/2a68453e-3a00-4d83-beaf-1f25a2e64a4f',
            width: 1600,
            height: 1024,
        },
        wikis: ['634', '2984', '5664', '13158'],
    },
    {
        id: '496',
        name: 'The Boys',
        color: '#C8E2F4',
        image: {
            url: 'https://vignette.wikia.nocookie.net/70cf0974-05bd-472f-bc2c-f76c7fb8a9f9',
            width: 1600,
            height: 1024,
        },
        wikis: ['1819740'],
    },
    {
        id: '254',
        name: 'Mash',
        color: '#66a159',
        image: {
            url: 'https://vignette.wikia.nocookie.net/3ff93795-8d1f-41c0-bef4-39fe1d79e531',
            width: 1600,
            height: 1024,
        },
        wikis: ['913'],
    },
    {
        id: '133',
        name: 'Far Cry',
        color: '#138eac',
        image: {
            url: 'https://vignette.wikia.nocookie.net/6da77f56-0efd-4f2d-a938-eb8a14d4090b',
            width: 1600,
            height: 1024,
        },
        wikis: ['3144', '69181', '499578', '524445', '636297', '887519'],
    },
    {
        id: '497',
        name: 'Cobra Kai / Karate Kid',
        color: '#712B1B',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c4fc8197-1bbe-48e0-8a5d-b49f7e260daa',
            width: 1600,
            height: 1024,
        },
        wikis: ['102065'],
    },
    {
        id: '376',
        name: 'This Is Us',
        color: '#cbd5d3',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e3eec885-1403-4b67-ab9a-1f55a79aa30d',
            width: 1600,
            height: 1024,
        },
        wikis: ['1906473'],
    },
    {
        id: '255',
        name: 'Cocktails',
        color: '#d13bc2',
        image: {
            url: 'https://vignette.wikia.nocookie.net/08fcd5c5-1213-4a58-a61b-667b706a2cef',
            width: 1600,
            height: 1024,
        },
        wikis: ['8390', '959655'],
    },
    {
        id: '134',
        name: 'Teen-Titans-Go',
        color: '#ed1590',
        image: {
            url: 'https://vignette.wikia.nocookie.net/35095f6a-8271-4b66-9d6b-e10f64fa62f9',
            width: 1600,
            height: 1024,
        },
        wikis: ['618630', '789620', '823674'],
    },
    {
        id: '498',
        name: 'Ted Lasso',
        color: '#427F32',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f5fcd916-e4b8-4c17-b1bb-3fd8832a7b1d',
            width: 1600,
            height: 1024,
        },
        wikis: ['2323532'],
    },
    {
        id: '256',
        name: 'Lady Gaga',
        color: '#53c8df',
        image: {
            url: 'https://vignette.wikia.nocookie.net/5b15d132-caa9-4db9-b40d-cac7b7f3776a',
            width: 1600,
            height: 1024,
        },
        wikis: ['13022', '155013', '433583'],
    },
    {
        id: '135',
        name: 'Five Nights at Treasure Island',
        color: '#b71515',
        image: {
            url: 'https://vignette.wikia.nocookie.net/eed930d8-9730-4caa-b156-0daffb322171',
            width: 1600,
            height: 1024,
        },
        wikis: ['1064403', '1093582'],
    },
    {
        id: '499',
        name: 'The Dragon Prince',
        color: '#202f5b',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f1fb467a-6d25-47e7-ab61-c256c020170b',
            width: 1600,
            height: 1024,
        },
        wikis: ['1768528', '1898062'],
    },
    {
        id: '378',
        name: 'Yellowstone',
        color: '#ffffff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/a0816365-a49f-48ed-9142-c31a8a9bccc9',
            width: 1080,
            height: 1080,
        },
        wikis: ['2231167'],
    },
    {
        id: '257',
        name: 'Orphan Black',
        color: '#269db7',
        image: {
            url: 'https://vignette.wikia.nocookie.net/350fa055-2e50-4670-881a-0c0062823fbe',
            width: 1600,
            height: 1024,
        },
        wikis: ['701294', '1162966'],
    },
    {
        id: '136',
        name: 'Ghost Recon',
        color: '#1f5d6d',
        image: {
            url: 'https://vignette.wikia.nocookie.net/4c84d992-6754-4b3a-97d0-ce5af0c5183f',
            width: 1600,
            height: 1024,
        },
        wikis: ['3212', '66076'],
    },
    {
        id: '379',
        name: 'Apex Legends',
        color: '#e5e2d8',
        image: {
            url: 'https://static.wikia.nocookie.net/633475c3-edfb-4265-a88a-99f6e232005c',
            width: 1600,
            height: 1024,
        },
        wikis: [],
    },
    {
        id: '258',
        name: 'Heroes of the Storm',
        color: '#3250e4',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c53482d7-1282-4aa3-b520-0e2eb950ffa6',
            width: 1600,
            height: 1024,
        },
        wikis: ['850334', '921680', '1002717'],
    },
    {
        id: '137',
        name: 'Street Fighter',
        color: '#e56c10',
        image: {
            url: 'https://vignette.wikia.nocookie.net/9bf9bd34-070a-4f35-8af5-f2fa64d55007',
            width: 1600,
            height: 1024,
        },
        wikis: ['4492', '35539'],
    },
    {
        id: '259',
        name: 'Might and Magic',
        color: '#d14e16',
        image: {
            url: 'https://vignette.wikia.nocookie.net/83fcf4ba-b7ed-497a-a316-e87975c211de',
            width: 1600,
            height: 1024,
        },
        wikis: ['2503', '421599'],
    },
    {
        id: '138',
        name: 'AVP',
        color: '#0f5b84',
        image: {
            url: 'https://vignette.wikia.nocookie.net/8ac9dfac-14b4-404f-8443-19b2cc67143d',
            width: 1600,
            height: 1024,
        },
        wikis: ['1538', '33389', '894769'],
    },
    {
        id: '139',
        name: 'Gran Turismo',
        color: '#c11616',
        image: {
            url: 'https://vignette.wikia.nocookie.net/5e587eb8-20e8-47d5-8a35-da2d0535cfa4',
            width: 1600,
            height: 1024,
        },
        wikis: ['7060', '32565', '152238'],
    },
    {
        id: '31',
        name: 'Wonder Woman',
        color: '#fd0b23',
        image: {
            url: 'https://static.wikia.nocookie.net/12e6a0f2-7996-4822-8038-d48ee5e5c920',
            width: 1600,
            height: 1024,
        },
        wikis: ['866'],
    },
    {
        id: '32',
        name: 'GTA',
        color: '#feebb9',
        image: {
            url: 'https://vignette.wikia.nocookie.net/07ad1c62-922b-4e7a-b6d3-6d442c527391',
            width: 1600,
            height: 1024,
        },
        wikis: ['846', '1733', '2583', '3253', '4541', '6051', '9145', '491291'],
    },
    {
        id: '33',
        name: 'Pokemon',
        color: '#e90000',
        image: {
            url: 'https://vignette.wikia.nocookie.net/bc31e0dd-9d8d-4820-aa07-1713666d5775',
            width: 1600,
            height: 1024,
        },
        wikis: ['74', '1221', '6918', '28533', '121833', '201843', '750910'],
    },
    {
        id: '34',
        name: 'Elder Scrolls',
        color: '#7e88a8',
        image: {
            url: 'https://vignette.wikia.nocookie.net/29faee51-54c2-422f-9688-2c5017b09b2b',
            width: 1600,
            height: 1024,
        },
        wikis: ['1706', '2520', '2841', '6866', '8708', '68170', '368083', '422454'],
    },
    {
        id: '35',
        name: 'Dragon Ball',
        color: '#f0724c',
        image: {
            url: 'https://vignette.wikia.nocookie.net/d5e069f8-14af-4f8b-b661-7e2213481610',
            width: 1600,
            height: 1024,
        },
        wikis: ['530', '1350', '1744', '8619', '31477', '35749', '127335', '457054', '558403'],
    },
    {
        id: '36',
        name: 'Harry Potter',
        color: '#bd2c2a',
        image: {
            url: 'https://vignette.wikia.nocookie.net/631201a6-0748-4cdb-972b-cbd1157fcab4',
            width: 1600,
            height: 1024,
        },
        wikis: ['509', '1044', '1965', '1978', '2158', '4259', '4267', '12318', '115049', '865669'],
    },
    {
        id: '37',
        name: 'Fallout',
        color: '#4f80b8',
        image: {
            url: 'https://vignette.wikia.nocookie.net/063a18f3-26be-477b-b705-4e1ccc5f1f07',
            width: 1600,
            height: 1024,
        },
        wikis: ['3035', '3063', '3064', '3468', '3469', '10994', '14988', '36489'],
    },
    {
        id: '38',
        name: 'Super Mario',
        color: '#3a8dff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c1060e67-5f1e-4ad7-9071-0074523a055d',
            width: 1600,
            height: 1024,
        },
        wikis: ['3473', '4284'],
    },
    {
        id: '39',
        name: 'Star Wars',
        color: '#d45422',
        image: {
            url: 'https://vignette.wikia.nocookie.net/fea2f2c2-a178-4c71-8f67-9e07ee2d01b6',
            width: 1600,
            height: 1024,
        },
        wikis: ['147', '750', '916', '1473', '1530', '1707', '3786', '5931', '280741'],
    },
    {
        id: '380',
        name: 'Honest Trailers',
        color: '#3e8b28',
        image: {
            url: 'https://static.wikia.nocookie.net/6a79e6f2-b2e9-4b0f-bc25-0716d58ea2c4',
            width: 1600,
            height: 1024,
        },
        wikis: [],
    },
    {
        id: '260',
        name: 'Ghostbusters',
        color: '#66b215',
        image: {
            url: 'https://vignette.wikia.nocookie.net/9ce5d010-4149-4c87-9190-97f04a963f1c',
            width: 1600,
            height: 1024,
        },
        wikis: ['1585', '1424655'],
    },
    {
        id: '382',
        name: 'Dokkan Battle',
        color: '#41aefa',
        image: {
            url: 'https://vignette.wikia.nocookie.net/2fd2c7ca-ac2c-43d5-a4f1-aab376351446',
            width: 1600,
            height: 1024,
        },
        wikis: ['1254589', '1505241'],
    },
    {
        id: '261',
        name: 'Scandal',
        color: '#66b215',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ab4a4b77-63ea-43d3-903b-9c5140834194',
            width: 1600,
            height: 1024,
        },
        wikis: ['281638', '1040046'],
    },
    {
        id: '140',
        name: 'Gwent',
        color: '#089272',
        image: {
            url: 'https://vignette.wikia.nocookie.net/08b7c50b-1f55-4e46-a410-2a196a686562',
            width: 1600,
            height: 1024,
        },
        wikis: ['1417152', '1541138'],
    },
    {
        id: '383',
        name: 'VS Battles',
        color: '#16858a',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ab14967e-ee76-45e8-b85f-b5a261940ae5',
            width: 1600,
            height: 1024,
        },
        wikis: ['175043'],
    },
    {
        id: '262',
        name: 'Tales',
        color: '#6eaf5a',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f78ceca5-83fb-41f0-bb89-de43cda65957',
            width: 1600,
            height: 1024,
        },
        wikis: ['1042788', '1303298'],
    },
    {
        id: '141',
        name: 'Card Fight',
        color: '#da3012',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b364f40f-779b-4f66-abee-0a409a44bccb',
            width: 1600,
            height: 1024,
        },
        wikis: ['185111', '558032'],
    },
    {
        id: '384',
        name: 'Brawl Stars',
        color: '#2bbced',
        image: {
            url: 'https://vignette.wikia.nocookie.net/45237fb1-4355-4c4e-8cbf-ef8abbff4d8f',
            width: 1600,
            height: 1024,
        },
        wikis: ['1583174', '1780328'],
    },
    {
        id: '263',
        name: 'Utaite',
        color: '#42e89b',
        image: {
            url: 'https://vignette.wikia.nocookie.net/3b8df908-775c-4c2e-aed4-58aa771d859a',
            width: 1600,
            height: 1024,
        },
        wikis: ['72688'],
    },
    {
        id: '142',
        name: 'Maze Runner',
        color: '#366e63',
        image: {
            url: 'https://vignette.wikia.nocookie.net/bbf293f5-2e06-4232-a1bd-8d1a11748fa7',
            width: 1600,
            height: 1024,
        },
        wikis: ['114341', '350600', '940341', '1062250'],
    },
    {
        id: '385',
        name: 'Sekiro',
        color: '#b6c8cb',
        image: {
            url: 'https://vignette.wikia.nocookie.net/65709237-94be-4005-8bc5-1379bc3de01d',
            width: 1600,
            height: 1024,
        },
        wikis: ['1740328', '1752205', '1933957'],
    },
    {
        id: '264',
        name: 'Recipes',
        color: '#1a9a34',
        image: {
            url: 'https://vignette.wikia.nocookie.net/721dacfe-2a36-49b3-ab18-f206a47827c9',
            width: 1600,
            height: 1024,
        },
        wikis: ['3355', '910845'],
    },
    {
        id: '143',
        name: 'Slime Rancher',
        color: '#4fb3c0',
        image: {
            url: 'https://vignette.wikia.nocookie.net/6b497e6b-e487-44be-8d8f-c95f9bad48db',
            width: 1600,
            height: 1024,
        },
        wikis: ['1075831', '1331286'],
    },
    {
        id: '386',
        name: 'Seven Deadly Sins',
        color: '#52b8ce',
        image: {
            url: 'https://vignette.wikia.nocookie.net/8a4f3c57-e39f-4e24-bcb0-12cd70b246c6',
            width: 1600,
            height: 1024,
        },
        wikis: ['643102', '679923', '928415', '958896', '1019478', '1071125', '1156377', '1693808'],
    },
    {
        id: '265',
        name: 'Valiant Comics',
        color: '#306fc3',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c0da0478-ce0f-45b2-acde-8c3150e7776e',
            width: 1600,
            height: 1024,
        },
        wikis: ['1475259'],
    },
    {
        id: '144',
        name: 'Battle for Dream Island',
        color: '#2196da',
        image: {
            url: 'https://vignette.wikia.nocookie.net/01977be9-5219-4ee9-b438-fe35ed0fd6ad',
            width: 1600,
            height: 1024,
        },
        wikis: ['249799'],
    },
    {
        id: '387',
        name: 'Twilight',
        color: '#728d8d',
        image: {
            url: 'https://vignette.wikia.nocookie.net/0ff740fe-7841-4ff4-a579-46db2ffc61e4',
            width: 1600,
            height: 1024,
        },
        wikis: ['5687', '53191', '302279'],
    },
    {
        id: '266',
        name: "Mirror's Edge",
        color: '#e12929',
        image: {
            url: 'https://vignette.wikia.nocookie.net/731f8215-60cb-4b5c-96fe-3aa4c4a0dfdc',
            width: 1600,
            height: 1024,
        },
        wikis: ['8226', '995680'],
    },
    {
        id: '145',
        name: "Grey's Anatomy",
        color: '#4cc0d2',
        image: {
            url: 'https://vignette.wikia.nocookie.net/43b5ac49-8437-4059-9fcb-513cc3bed1ba',
            width: 1600,
            height: 1024,
        },
        wikis: ['2180', '23790', '362583'],
    },
    {
        id: '388',
        name: 'Rage',
        color: '#ffc900',
        image: {
            url: 'https://vignette.wikia.nocookie.net/a9ceafb5-929b-4bfa-acca-5bda14d8d7db',
            width: 1600,
            height: 1024,
        },
        wikis: ['14100', '355320', '483432', '681854'],
    },
    {
        id: '267',
        name: 'Beer',
        color: '#2991e1',
        image: {
            url: 'https://vignette.wikia.nocookie.net/1cd1a1ee-3ee0-4b50-97e0-1a1c929a7c75',
            width: 1600,
            height: 1024,
        },
        wikis: ['442', '712449'],
    },
    {
        id: '146',
        name: 'The Binding of Isaac',
        color: '#a31616',
        image: {
            url: 'https://vignette.wikia.nocookie.net/bd8e4681-3c5f-4cf6-9c85-1d921cfc3625',
            width: 1600,
            height: 1024,
        },
        wikis: ['394524', '454463', '458479', '471927', '491937', '544824'],
    },
    {
        id: '389',
        name: 'Yakuza',
        color: '#c2c5d0',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c6a81e11-2bf7-4899-b8a4-6b10d16a9007',
            width: 1600,
            height: 1024,
        },
        wikis: ['26903'],
    },
    {
        id: '268',
        name: 'WildStar',
        color: '#1f89db',
        image: {
            url: 'https://vignette.wikia.nocookie.net/dbe19292-7e22-44b0-b30e-353c9b33edd9',
            width: 1600,
            height: 1024,
        },
        wikis: ['352738', '941701', '968878', '983392'],
    },
    {
        id: '269',
        name: 'American Gods',
        color: '#138ca8',
        image: {
            url: 'https://vignette.wikia.nocookie.net/db69b1e6-d83c-4c09-ae53-d799e16a73da',
            width: 1600,
            height: 1024,
        },
        wikis: ['227440', '1578323'],
    },
    {
        id: '148',
        name: 'Skylanders',
        color: '#2b6998',
        image: {
            url: 'https://vignette.wikia.nocookie.net/9216c460-b390-4736-8514-64d93ad98849',
            width: 1600,
            height: 1024,
        },
        wikis: ['244592', '410935', '419006', '774975'],
    },
    {
        id: '149',
        name: 'Saints Row',
        color: '#5b2e82',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ad964687-f3d4-4ce4-8f4e-09ef9ebbdf72',
            width: 1600,
            height: 1024,
        },
        wikis: ['4470', '102147', '461766'],
    },
    {
        id: '40',
        name: 'Angry Birds',
        color: '#11a7cf',
        image: {
            url: 'https://vignette.wikia.nocookie.net/31215593-b2ee-44f8-9ce0-9ee125affe79',
            width: 1600,
            height: 1024,
        },
        wikis: ['120639', '350809', '486874', '549723', '642845'],
    },
    {
        id: '42',
        name: 'Gravity Falls',
        color: '#0d6478',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c017982c-58af-435f-a13f-10adf6a23469',
            width: 1600,
            height: 1024,
        },
        wikis: ['218059', '521271', '570205', '744464', '1097568'],
    },
    {
        id: '43',
        name: 'Call of Duty',
        color: '#161f2a',
        image: {
            url: 'https://vignette.wikia.nocookie.net/7817209a-ac32-48a1-96d9-0a83a7cb8cb8',
            width: 1600,
            height: 1024,
        },
        wikis: ['3125', '4692', '6805', '13819', '57087', '63123', '350781'],
    },
    {
        id: '44',
        name: 'Splatoon',
        color: '#ff2dd2',
        image: {
            url: 'https://vignette.wikia.nocookie.net/d5ca25d5-9f1b-4da4-968d-70aaef943b03',
            width: 1600,
            height: 1024,
        },
        wikis: ['989097', '1197050'],
    },
    {
        id: '45',
        name: 'Marvel',
        color: '#ffcb00',
        image: {
            url: 'https://vignette.wikia.nocookie.net/6b18cf66-a6aa-49c0-8220-8405d14cde67',
            width: 1600,
            height: 1024,
        },
        wikis: ['2233', '19548', '20113', '71021', '94755', '97123', '183473', '536148'],
    },
    {
        id: '46',
        name: 'Minecraft',
        color: '#cdeeb0',
        image: {
            url: 'https://vignette.wikia.nocookie.net/7275e02a-8f07-44c9-b1b4-a3f95acf4054',
            width: 1600,
            height: 1024,
        },
        wikis: ['2293617', '2293951', '2294046', '2294461'],
    },
    {
        id: '47',
        name: 'Anime',
        color: '#58c1d7',
        image: {
            url: 'https://static.wikia.nocookie.net/305b9d80-07e2-4ab0-b3ca-708c3c8f5c6e',
            width: 1600,
            height: 1024,
        },
        wikis: ['2378', '4395', '7474', '14517', '25735', '770685'],
    },
    {
        id: '48',
        name: "Assassin's Creed",
        color: '#b3d9de',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ab9b97d0-9108-4968-b53c-1f0c9d28a83c',
            width: 1600,
            height: 1024,
        },
        wikis: ['3510', '6663', '11710', '13794', '82666', '89404', '151346', '161263', '366313'],
    },
    {
        id: '49',
        name: 'DC',
        color: '#bb070e',
        image: {
            url: 'https://vignette.wikia.nocookie.net/78b34e25-bef2-4684-b25d-1ed915142aa2',
            width: 1600,
            height: 1024,
        },
        wikis: ['2237', '10283', '220183', '672544', '1430681'],
    },
    {
        id: '390',
        name: 'Total War',
        color: '#cbc5b9',
        image: {
            url: 'https://vignette.wikia.nocookie.net/bf7041e2-d847-4c7a-9425-d191423bfe2b',
            width: 1600,
            height: 1024,
        },
        wikis: ['1491', '54649'],
    },
    {
        id: '391',
        name: 'Anno 1800',
        color: '#a4add4',
        image: {
            url: 'https://vignette.wikia.nocookie.net/76f7480a-635a-484d-b4b6-69c0ecc3f1fd',
            width: 1600,
            height: 1024,
        },
        wikis: ['1612922', '1800494'],
    },
    {
        id: '270',
        name: 'Ayakashi Ghost Guild',
        color: '#4db3d2',
        image: {
            url: 'https://vignette.wikia.nocookie.net/d1371dc2-3304-4f50-8c9f-64f83dda590c',
            width: 1600,
            height: 1024,
        },
        wikis: ['547359', '608004', '690214'],
    },
    {
        id: '392',
        name: 'Gilmore Girls',
        color: '#67a2b3',
        image: {
            url: 'https://vignette.wikia.nocookie.net/92daecda-8c94-4776-a10b-eab78d4c77ca',
            width: 1600,
            height: 1024,
        },
        wikis: ['2703', '479985'],
    },
    {
        id: '271',
        name: 'Mad Men',
        color: '#db1f1f',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b5ee2f85-b56b-4e0d-a07e-87a1298454e4',
            width: 1600,
            height: 1024,
        },
        wikis: ['39401', '195690', '534443'],
    },
    {
        id: '150',
        name: 'Life Is Strange',
        color: '#e31db8',
        image: {
            url: 'https://vignette.wikia.nocookie.net/6eaf1f01-4e11-47a2-8fe0-b88e7c845b47',
            width: 1600,
            height: 1024,
        },
        wikis: ['1023891', '1180503', '1195607', '1199790', '1641010'],
    },
    {
        id: '393',
        name: 'Lucifer',
        color: '#940508',
        image: {
            url: 'https://vignette.wikia.nocookie.net/41ca26a4-211b-462d-a941-22e13af742af',
            width: 1600,
            height: 1024,
        },
        wikis: ['745286', '1324415', '1425078', '1586689', '1627667', '1661834'],
    },
    {
        id: '272',
        name: 'Battleborn',
        color: '#4aa7c8',
        image: {
            url: 'https://vignette.wikia.nocookie.net/a655a171-6a40-4e69-b4cd-cd8a9aedb4fc',
            width: 1600,
            height: 1024,
        },
        wikis: ['137054', '148136', '1004775', '1271428'],
    },
    {
        id: '151',
        name: 'My Singing Monsters',
        color: '#23a3bd',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ffa234a8-93cd-4702-8d03-a5120d9121b5',
            width: 1600,
            height: 1024,
        },
        wikis: ['599406', '791980'],
    },
    {
        id: '394',
        name: 'Scooby-Doo',
        color: '#67278a',
        image: {
            url: 'https://vignette.wikia.nocookie.net/a46eff71-2091-495b-9890-0fa9c22d9235',
            width: 1600,
            height: 1024,
        },
        wikis: ['2154', '204228', '644867', '1240833'],
    },
    {
        id: '273',
        name: 'Spiderman',
        color: '#f0c829',
        image: {
            url: 'https://vignette.wikia.nocookie.net/d133e33d-4726-4cc5-be43-a97306aa1369',
            width: 1600,
            height: 1024,
        },
        wikis: ['695', '76967'],
    },
    {
        id: '152',
        name: 'Warhammer Fantasy',
        color: '#ee7e14',
        image: {
            url: 'https://vignette.wikia.nocookie.net/1687f6a6-4be4-47e6-90b2-81dee6dceb08',
            width: 1600,
            height: 1024,
        },
        wikis: ['151693', '245032'],
    },
    {
        id: '395',
        name: 'That Time I Got Reincarnated as a Slime',
        color: '#c8cc29',
        image: {
            url: 'https://vignette.wikia.nocookie.net/788591bf-6dbc-4b04-b8e3-26c78ea782cb',
            width: 1600,
            height: 1024,
        },
        wikis: ['1230965', '1834073', '1876752'],
    },
    {
        id: '274',
        name: 'Bourne',
        color: '#2f88a8',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b0069102-52f1-459f-bc8c-6719bdfb89e4',
            width: 1600,
            height: 1024,
        },
        wikis: ['3680'],
    },
    {
        id: '153',
        name: 'Terminator',
        color: '#091c82',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ec114496-7e9f-4a58-9ff5-2a86b8812111',
            width: 1600,
            height: 1024,
        },
        wikis: ['2956', '4015', '13607', '1236299'],
    },
    {
        id: '396',
        name: 'The Rising of the Shield Hero',
        color: '#50c1c2',
        image: {
            url: 'https://vignette.wikia.nocookie.net/2da480c6-5d1a-40d9-ab01-bdd7ffe62479',
            width: 1600,
            height: 1024,
        },
        wikis: ['1048231'],
    },
    {
        id: '154',
        name: 'Sailor Moon',
        color: '#22b8cc',
        image: {
            url: 'https://vignette.wikia.nocookie.net/76f4e6a2-5385-4d6c-84c5-0b5be995d838',
            width: 1600,
            height: 1024,
        },
        wikis: ['537', '3273', '34159', '103896'],
    },
    {
        id: '397',
        name: 'Type-Moon',
        color: '#4b52d1',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b69c7148-1c42-4bf7-beff-012a194105b9',
            width: 1600,
            height: 1024,
        },
        wikis: ['3775', '54143', '113322', '354599', '460193', '1467712', '1646994'],
    },
    {
        id: '276',
        name: 'Ashes of Creation',
        color: '#2c0808',
        image: {
            url: 'https://vignette.wikia.nocookie.net/3766e446-e250-4461-b0cb-6f77bfe7fcdf',
            width: 1600,
            height: 1024,
        },
        wikis: ['1506615'],
    },
    {
        id: '155',
        name: 'LoL',
        color: '#1697b1',
        image: {
            url: 'https://vignette.wikia.nocookie.net/132be3c2-f859-45dd-be86-d2bc06b13bc0',
            width: 1600,
            height: 1024,
        },
        wikis: ['14764', '123589', '154642', '158526', '169198', '185960', '545299', '595609', '1322734'],
    },
    {
        id: '398',
        name: 'X-Men Movies',
        color: '#2e136d',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ae3f08f2-cff4-4032-b2b8-3e382bb653c0',
            width: 1600,
            height: 1024,
        },
        wikis: ['212757', '279451', '957262'],
    },
    {
        id: '277',
        name: 'Downton Abbey',
        color: '#3999d1',
        image: {
            url: 'https://vignette.wikia.nocookie.net/4091cb70-01f9-4835-b806-6b31b8b241f9',
            width: 1600,
            height: 1024,
        },
        wikis: ['167846', '655916', '926698'],
    },
    {
        id: '156',
        name: 'Grimm',
        color: '#04a47c',
        image: {
            url: 'https://vignette.wikia.nocookie.net/49a92430-22e8-46ae-ac58-fce788d29030',
            width: 1600,
            height: 1024,
        },
        wikis: ['106540', '528847', '535645', '583981', '696594'],
    },
    {
        id: '399',
        name: 'DC Extended Universe',
        color: '#1579ee',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b3bc16ee-dd78-496e-b7f4-d1f9622da09c',
            width: 1600,
            height: 1024,
        },
        wikis: ['764072', '1172203', '1239688', '1757401'],
    },
    {
        id: '278',
        name: 'Preacher',
        color: '#ad0fc5',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e84c8721-938c-45ba-aa09-9ebda44e2ae6',
            width: 1600,
            height: 1024,
        },
        wikis: ['1086357'],
    },
    {
        id: '157',
        name: 'Naruto',
        color: '#00b9e3',
        image: {
            url: 'https://vignette.wikia.nocookie.net/1f52e40a-b460-427d-8259-f5342e76d9c8',
            width: 1600,
            height: 1024,
        },
        wikis: ['1318', '4344', '5656', '6236', '7471', '7900', '178802'],
    },
    {
        id: '279',
        name: 'Knights of Sidonia',
        color: '#223eb9',
        image: {
            url: 'https://vignette.wikia.nocookie.net/bd674f9b-0ed8-4687-9533-9afecbe75df4',
            width: 1600,
            height: 1024,
        },
        wikis: ['848580', '1144697'],
    },
    {
        id: '158',
        name: 'James Bond',
        color: '#ac9556',
        image: {
            url: 'https://vignette.wikia.nocookie.net/0e4cc145-d9ae-4f5c-8763-315e73cf754d',
            width: 1600,
            height: 1024,
        },
        wikis: ['596', '7643', '11083', '1116392'],
    },
    {
        id: '159',
        name: 'Steven Universe',
        color: '#ac83da',
        image: {
            url: 'https://vignette.wikia.nocookie.net/28d331dd-cfc4-47f0-bf57-802fe21e3c9c',
            width: 1600,
            height: 1024,
        },
        wikis: ['621556', '711348', '877287', '930697', '1036242', '1089995'],
    },
    {
        id: '50',
        name: 'Overwatch',
        color: '#d3d7e7',
        image: {
            url: 'https://vignette.wikia.nocookie.net/05866046-423c-4e98-9ae5-5fc879d8b07b',
            width: 1600,
            height: 1024,
        },
        wikis: ['1073395', '1074269', '1304225', '1363059', '1389987', '2293814'],
    },
    {
        id: '51',
        name: 'Disney',
        color: '#f0e046',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c00456b5-d019-48cf-b13c-51f45d4ac498',
            width: 1600,
            height: 1024,
        },
        wikis: ['374', '3155', '13042', '77157', '129377', '157454', '164162', '347457', '1612188'],
    },
    {
        id: '52',
        name: 'The Walking Dead',
        color: '#ca141b',
        image: {
            url: 'https://vignette.wikia.nocookie.net/fb9b28bd-2b8b-411b-8e55-25e349120242',
            width: 1600,
            height: 1024,
        },
        wikis: ['13346', '190497', '392745', '504037', '700015', '815313'],
    },
    {
        id: '53',
        name: 'MCU',
        color: '#2b67b8',
        image: {
            url: 'https://static.wikia.nocookie.net/a14d6fed-8921-49fa-b42e-b547b8623d49',
            width: 1600,
            height: 1024,
        },
        wikis: ['177996', '536148', '1183354', '1201742', '1251819'],
    },
    {
        id: '54',
        name: 'Simpsons',
        color: '#ffd920',
        image: {
            url: 'https://vignette.wikia.nocookie.net/70bd3436-9be9-4ef7-9b8d-8116960c9ad9',
            width: 1600,
            height: 1024,
        },
        wikis: ['673', '1217', '1813', '2680', '3937', '6634', '268608', '381531'],
    },
    {
        id: '55',
        name: 'Star Trek',
        color: '#a9f0f4',
        image: {
            url: 'https://static.wikia.nocookie.net/f4a1cf12-5b77-426e-abc0-9ab6a00f340e',
            width: 1600,
            height: 1024,
        },
        wikis: ['113', '114', '548', '763', '1260', '2421', '2556', '5379', '6613'],
    },
    {
        id: '56',
        name: 'Stranger Things',
        color: '#220000',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ff438516-f4de-4264-8879-30f198045271',
            width: 1600,
            height: 1024,
        },
        wikis: ['1432063', '1432345', '1441547', '1446906', '1451041', '1453377'],
    },
    {
        id: '57',
        name: 'Batman',
        color: '#ffed39',
        image: {
            url: 'https://vignette.wikia.nocookie.net/86c9ce8a-3ad8-406c-a540-e1bcdb409c4e',
            width: 1600,
            height: 1024,
        },
        wikis: ['3166', '9252', '29845', '320744'],
    },
    {
        id: '58',
        name: 'Destiny',
        color: '#68d0b8',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c691fcc2-63d8-47ad-9b2a-db595feed042',
            width: 1600,
            height: 1024,
        },
        wikis: ['604797', '648592', '695084', '804601', '998092', '1018799'],
    },
    {
        id: '59',
        name: 'Final Fantasy',
        color: '#273147',
        image: {
            url: 'https://vignette.wikia.nocookie.net/60404d5d-4ea1-4c39-b973-1cf16f42008e',
            width: 1600,
            height: 1024,
        },
        wikis: ['174', '1115', '1620', '2407', '4066', '4875', '5982', '6234', '39618'],
    },
    {
        id: '280',
        name: 'Survivor',
        color: '#d96d15',
        image: {
            url: 'https://vignette.wikia.nocookie.net/72c9ce6b-f928-43fc-bc33-0cb578c6ae10',
            width: 1600,
            height: 1024,
        },
        wikis: ['1166', '674797'],
    },
    {
        id: '281',
        name: 'Subnautica',
        color: '#2c83c5',
        image: {
            url: 'https://vignette.wikia.nocookie.net/55cf343a-9c7c-4359-8d56-d85192e4c656',
            width: 1600,
            height: 1024,
        },
        wikis: ['1079837', '1149584', '1223836', '1357037'],
    },
    {
        id: '160',
        name: 'Gundam',
        color: '#0c6876',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b5ed0f51-ddd3-4d10-9953-8d16d66f4cf4',
            width: 1600,
            height: 1024,
        },
        wikis: ['932', '12795', '50653'],
    },
    {
        id: '282',
        name: 'Boku no Hero Academia',
        color: '#fffdf1',
        image: {
            url: 'https://vignette.wikia.nocookie.net/6865d4ac-5358-4a14-90a5-9201ed1edd2b',
            width: 1600,
            height: 1024,
        },
        wikis: ['997342', '1102017', '1386469', '1582345', '1605264'],
    },
    {
        id: '161',
        name: 'The 100',
        color: '#136976',
        image: {
            url: 'https://vignette.wikia.nocookie.net/79cc433e-48b1-4d6b-a8cf-35d1e98423b9',
            width: 1600,
            height: 1024,
        },
        wikis: ['750919', '943167', '960885', '1143903'],
    },
    {
        id: '283',
        name: 'Studio Ghibli',
        color: '#19bc7b',
        image: {
            url: 'https://vignette.wikia.nocookie.net/8334bddc-47cb-4c77-a9ae-fe5ae41c14cc',
            width: 1600,
            height: 1024,
        },
        wikis: ['186256', '294811'],
    },
    {
        id: '162',
        name: 'Adventure Time',
        color: '#86efff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/64dc23be-a82f-44ef-8c99-5273b20c7ddd',
            width: 1600,
            height: 1024,
        },
        wikis: ['24357', '149192', '498482', '531317', '556684', '562763', '575334'],
    },
    {
        id: '284',
        name: 'Overlord',
        color: '#cd1515',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b368eb41-4b7d-4267-a3f1-6c8c5208e14f',
            width: 1600,
            height: 1024,
        },
        wikis: ['1136286', '1247519'],
    },
    {
        id: '163',
        name: "No Man's Sky",
        color: '#4fd9c4',
        image: {
            url: 'https://vignette.wikia.nocookie.net/75c9b745-6d30-46b8-acc5-c2c9fad861d1',
            width: 1600,
            height: 1024,
        },
        wikis: ['1276183', '1307239', '1395361', '2294400'],
    },
    {
        id: '285',
        name: 'Criminal Minds',
        color: '#16627a',
        image: {
            url: 'https://vignette.wikia.nocookie.net/944d0b6b-dadb-4b32-b8fb-e77bc45a6882',
            width: 1600,
            height: 1024,
        },
        wikis: ['12114', '95016', '701218'],
    },
    {
        id: '164',
        name: 'One Direction',
        color: '#da566c',
        image: {
            url: 'https://vignette.wikia.nocookie.net/948034cf-b1b9-4277-b1c2-efb97f9c0f59',
            width: 1600,
            height: 1024,
        },
        wikis: ['203914', '417441', '542184', '611772'],
    },
    {
        id: '286',
        name: 'God of War',
        color: '#149bc4',
        image: {
            url: 'https://vignette.wikia.nocookie.net/db7d1a75-997c-4c9a-9ad5-0444467ac718',
            width: 1600,
            height: 1024,
        },
        wikis: ['2935', '64701', '253217', '829359'],
    },
    {
        id: '165',
        name: 'Digimon',
        color: '#20699d',
        image: {
            url: 'https://vignette.wikia.nocookie.net/88741097-c945-4801-a9e2-ec994d05122a',
            width: 1600,
            height: 1024,
        },
        wikis: ['1055', '5473', '7052', '26526', '789592'],
    },
    {
        id: '287',
        name: '13 Reasons Why',
        color: '#374e70',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c9a1feda-b2b6-4d1d-861b-0c41af99304b',
            width: 1600,
            height: 1024,
        },
        wikis: ['524886', '1561425', '1562699', '1571352'],
    },
    {
        id: '166',
        name: 'Dishonored',
        color: '#44d2a7',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c1bda8d4-37e7-4e4a-b326-b59066696b9a',
            width: 1600,
            height: 1024,
        },
        wikis: ['331747', '562239', '613250', '626879'],
    },
    {
        id: '288',
        name: 'Drag Race',
        color: '#2597ba',
        image: {
            url: 'https://vignette.wikia.nocookie.net/3be6f9af-9459-4727-b58b-8b83ce8df411',
            width: 1600,
            height: 1024,
        },
        wikis: ['329982'],
    },
    {
        id: '167',
        name: 'South Park',
        color: '#1f6243',
        image: {
            url: 'https://vignette.wikia.nocookie.net/87f39e97-afe5-4c7f-9dff-f97dd07f6192',
            width: 1600,
            height: 1024,
        },
        wikis: ['835', '1831', '437880', '563513', '718894', '1200243'],
    },
    {
        id: '168',
        name: 'Fire Emblem',
        color: '#d8451c',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e2b25e3a-989a-4d55-8109-ab71130e248b',
            width: 1600,
            height: 1024,
        },
        wikis: ['941', '5731', '10280', '574353'],
    },
    {
        id: '60',
        name: 'Rick and Morty',
        color: '#df8356',
        image: {
            url: 'https://vignette.wikia.nocookie.net/5bad9e07-4e5e-477b-8d63-5afe14d27795',
            width: 1600,
            height: 1024,
        },
        wikis: ['881799', '1047275', '1517696', '1544649'],
    },
    {
        id: '61',
        name: 'Doctor Who',
        color: '#0d1e2b',
        image: {
            url: 'https://vignette.wikia.nocookie.net/d5943f1e-557b-4582-8c22-a3b7aa0656ac',
            width: 1600,
            height: 1024,
        },
        wikis: ['125', '7531', '9751', '126805', '487467', '581533'],
    },
    {
        id: '62',
        name: 'American Horror Story',
        color: '#7daba8',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b9a5f12b-b325-444c-8aef-807091f41233',
            width: 1600,
            height: 1024,
        },
        wikis: ['321995', '609635', '631711', '673070', '1015621', '1242270'],
    },
    {
        id: '63',
        name: 'Game of Thrones',
        color: '#7a958e',
        image: {
            url: 'https://static.wikia.nocookie.net/862766c9-89bc-4548-9249-71f377a1feb4',
            width: 1600,
            height: 1024,
        },
        wikis: ['7193', '130814', '134307', '430837', '443588', '475988', '729241', '789616', '878001'],
    },
    {
        id: '64',
        name: 'Ben 10',
        color: '#0f6e48',
        image: {
            url: 'https://vignette.wikia.nocookie.net/13db875f-3eeb-4212-bea2-7e5547af17d8',
            width: 1600,
            height: 1024,
        },
        wikis: ['3124', '5918', '9778', '10129', '80985', '432089', '1108430'],
    },
    {
        id: '65',
        name: 'Yu-Gi-Oh!',
        color: '#ee1c25',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ea0d2282-9a59-42c4-8e95-670ce03cec3a',
            width: 1600,
            height: 1024,
        },
        wikis: ['410', '8241', '9637', '9940', '164702', '169605', '763976'],
    },
    {
        id: '66',
        name: "Five Nights at Freddy's",
        color: '#0d3389',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f734ecbc-8b98-4615-8754-1bbdc4b97694',
            width: 1600,
            height: 1024,
        },
        wikis: ['1030684', '1030786', '1053128', '1064403', '1077583', '1080954', '1108130'],
    },
    {
        id: '67',
        name: 'Warframe',
        color: '#084a82',
        image: {
            url: 'https://vignette.wikia.nocookie.net/83fa306e-f11c-48c8-889d-c2840dd35e40',
            width: 1600,
            height: 1024,
        },
        wikis: ['544934', '685207', '692268', '718954', '723392', '724592', '739434', '750724', '823996'],
    },
    {
        id: '68',
        name: 'Terraria',
        color: '#0039e4',
        image: {
            url: 'https://vignette.wikia.nocookie.net/076b2a6a-ad5b-45f5-818e-4a6e20f8b3a7',
            width: 1600,
            height: 1024,
        },
        wikis: ['268217', '270461', '276141', '2294765'],
    },
    {
        id: '69',
        name: 'Mario',
        color: '#3a8dff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/47ccdb57-338f-45c6-b63f-fd940762f023',
            width: 1600,
            height: 1024,
        },
        wikis: ['3473', '3665', '4284', '12111', '493139'],
    },
    {
        id: '290',
        name: 'Superman',
        color: '#1d41c4',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e47b3af4-8b36-42c1-9d90-c54a09992c58',
            width: 1600,
            height: 1024,
        },
        wikis: ['1178'],
    },
    {
        id: '291',
        name: 'Hulu',
        color: '#2ec98b',
        image: {
            url: 'https://vignette.wikia.nocookie.net/7f8c23d7-c482-4f14-83d3-7125d2bcb791',
            width: 1600,
            height: 1024,
        },
        wikis: [],
    },
    {
        id: '170',
        name: 'Dance Moms',
        color: '#d2c144',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e0fe96af-10f6-4319-ba86-9434f184c9be',
            width: 1600,
            height: 1024,
        },
        wikis: ['303365'],
    },
    {
        id: '292',
        name: 'Yoshi',
        color: '#1dafdc',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f8f0d8fc-2657-45db-9924-3daca1fff72a',
            width: 1600,
            height: 1024,
        },
        wikis: ['10069'],
    },
    {
        id: '293',
        name: 'Tokyo Ghoul',
        color: '#b21e1e',
        image: {
            url: 'https://vignette.wikia.nocookie.net/290dc6fd-3caa-45f3-93cb-81ef59ae27a5',
            width: 1600,
            height: 1024,
        },
        wikis: ['909750', '1015651', '1018853', '1022884', '1090910'],
    },
    {
        id: '172',
        name: 'Big Bang Theory',
        color: '#196ba5',
        image: {
            url: 'https://vignette.wikia.nocookie.net/9856106c-4718-4afe-be37-a97350311e8b',
            width: 1600,
            height: 1024,
        },
        wikis: ['4828', '50202', '276757', '468418', '773305'],
    },
    {
        id: '294',
        name: 'Fortnite',
        color: '#b348a3',
        image: {
            url: 'https://vignette.wikia.nocookie.net/1c9dccf1-3a75-4b8a-bda9-1fa3fdab347f',
            width: 1600,
            height: 1024,
        },
        wikis: ['440321', '1605223', '1606279'],
    },
    {
        id: '173',
        name: 'Hunger Games',
        color: '#cf1c1c',
        image: {
            url: 'https://vignette.wikia.nocookie.net/5d16da7e-87f2-4924-83ee-fd47d2287c7a',
            width: 1600,
            height: 1024,
        },
        wikis: ['35171', '271374', '447651', '449963', '514697'],
    },
    {
        id: '295',
        name: 'Clash of Clans',
        color: '#48c8e3',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e1e7ab0e-bb39-49a2-b39a-92d3f76ce30e',
            width: 1600,
            height: 1024,
        },
        wikis: ['558247', '586492', '586931', '677653', '704662', '707989', '736434', '866809'],
    },
    {
        id: '174',
        name: 'Shadow of Mordor',
        color: '#ca7418',
        image: {
            url: 'https://vignette.wikia.nocookie.net/2db6679a-e279-4923-84d7-8aae913c52a3',
            width: 1600,
            height: 1024,
        },
        wikis: ['863039', '865330', '944419', '1041112', '1051526', '1054187'],
    },
    {
        id: '296',
        name: 'Hawaii Five O',
        color: '#0cb3a5',
        image: {
            url: 'https://vignette.wikia.nocookie.net/cfc289cd-aea4-41b8-824a-548dbc5c5907',
            width: 1600,
            height: 1024,
        },
        wikis: ['119235', '387133', '789637'],
    },
    {
        id: '175',
        name: 'Riverdale',
        color: '#327da8',
        image: {
            url: 'https://vignette.wikia.nocookie.net/5ae076fc-77d9-4e86-a622-a865db4e7ed8',
            width: 1600,
            height: 1024,
        },
        wikis: ['1063533', '1527867', '1535738', '1543110'],
    },
    {
        id: '176',
        name: 'DragonVale',
        color: '#1778b0',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b76db700-df19-4cec-b0c1-20c1edfae75b',
            width: 1600,
            height: 1024,
        },
        wikis: ['379993', '389109', '490373'],
    },
    {
        id: '298',
        name: 'Arrowverse',
        color: '#ceb355',
        image: {
            url: 'https://vignette.wikia.nocookie.net/43cf4ee1-7d84-4ba2-a696-344ae7c2152d',
            width: 1600,
            height: 1024,
        },
        wikis: ['250551', '629704', '639206', '762029', '851918', '921255', '1114277'],
    },
    {
        id: '177',
        name: 'Nicki Minaj',
        color: '#f57ceb',
        image: {
            url: 'https://vignette.wikia.nocookie.net/8132d1c8-b8be-4cc0-a8b7-a652eb4e77f1',
            width: 1600,
            height: 1024,
        },
        wikis: ['79512'],
    },
    {
        id: '299',
        name: 'Supernatural',
        color: '#af9f82',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e8f77704-f99e-41f6-8457-d2d7cd29a3fa',
            width: 1600,
            height: 1024,
        },
        wikis: ['4428', '41019', '44531', '67433', '81983'],
    },
    {
        id: '178',
        name: 'Villains',
        color: '#70b7ff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/d325fda4-24db-44ba-b7d4-5bc70fa5f9c6',
            width: 1600,
            height: 1024,
        },
        wikis: ['1544', '736459', '1396192'],
    },
    {
        id: '179',
        name: 'Jurassic Park',
        color: '#df1818',
        image: {
            url: 'https://vignette.wikia.nocookie.net/72eb9035-184f-431f-aa29-51ebcad53dcc',
            width: 1600,
            height: 1024,
        },
        wikis: ['1766', '9255', '80162', '733464'],
    },
    {
        id: '70',
        name: 'Super Smash Bros',
        color: '#ddca27',
        image: {
            url: 'https://vignette.wikia.nocookie.net/be471056-ea46-4245-9ead-fa3dd2811744',
            width: 1600,
            height: 1024,
        },
        wikis: ['2714', '100925', '859949'],
    },
    {
        id: '71',
        name: 'Nerf',
        color: '#0c6cb5',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f5885410-5653-4645-87e5-e219d34e4d16',
            width: 1600,
            height: 1024,
        },
        wikis: ['4444', '738089'],
    },
    {
        id: '72',
        name: 'Dark Souls',
        color: '#cbae44',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ac45c581-4255-41bb-a091-dba0a56f7004',
            width: 1600,
            height: 1024,
        },
        wikis: ['208733', '470065', '476932', '629602', '780741', '928967', '1393832'],
    },
    {
        id: '73',
        name: "Don't Starve",
        color: '#7f6e9f',
        image: {
            url: 'https://vignette.wikia.nocookie.net/3c006735-2184-4bec-973c-8a22b06c9e7e',
            width: 1600,
            height: 1024,
        },
        wikis: ['599420', '601762', '638551', '638810', '650858', '652791', '749375', '791072'],
    },
    {
        id: '74',
        name: 'Sonic',
        color: '#ac1b1b',
        image: {
            url: 'https://vignette.wikia.nocookie.net/2915fefa-b5e1-4592-a594-b8e766dff086',
            width: 1600,
            height: 1024,
        },
        wikis: ['663', '2793', '7942', '9409', '152771', '1362768', '1881203'],
    },
    {
        id: '75',
        name: 'Monster Hunter',
        color: '#56722b',
        image: {
            url: 'https://vignette.wikia.nocookie.net/66927cf2-0a7e-4cf8-ba78-9ec48640b75b',
            width: 1600,
            height: 1024,
        },
        wikis: ['3234', '329730', '351776', '408733', '741851'],
    },
    {
        id: '76',
        name: 'One Piece',
        color: '#0e8ec5',
        image: {
            url: 'https://vignette.wikia.nocookie.net/4428517f-b2d5-484c-90b2-2cd4f7b7682a',
            width: 1600,
            height: 1024,
        },
        wikis: ['1081', '6083', '8058', '9797', '11862', '12113', '13060', '47439', '53715', '165997'],
    },
    {
        id: '77',
        name: 'Miraculous Ladybug',
        color: '#54ccf4',
        image: {
            url: 'https://vignette.wikia.nocookie.net/45e99d89-9f68-4519-98ec-f89e1f8d53b3',
            width: 1600,
            height: 1024,
        },
        wikis: ['848200', '1250678', '1303140', '1305169', '1329428', '1357860', '1404019'],
    },
    {
        id: '78',
        name: 'The Witcher',
        color: '#96a3a6',
        image: {
            url: 'https://vignette.wikia.nocookie.net/92c5eb67-9ba2-4cfe-a020-fe8dc9819f44',
            width: 1600,
            height: 1024,
        },
        wikis: ['3443', '4542', '4543', '4701', '4984', '6053', '1105725', '2294986'],
    },
    {
        id: '79',
        name: 'Avatar the Last Airbender',
        color: '#6dcbe0',
        image: {
            url: 'https://vignette.wikia.nocookie.net/3e69d5a7-8643-44a8-a2a5-e5177c55f50e',
            width: 1600,
            height: 1024,
        },
        wikis: ['532', '4798', '7126', '7468', '9090', '10714', '613369'],
    },
    {
        id: '180',
        name: 'Tekken',
        color: '#b8954b',
        image: {
            url: 'https://vignette.wikia.nocookie.net/f0e7aa0f-b77b-4da5-9070-119c2d7b55ef',
            width: 1600,
            height: 1024,
        },
        wikis: ['3534', '7419', '524728', '671485', '671685'],
    },
    {
        id: '181',
        name: 'Avengers Alliance',
        color: '#1d2e77',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e8634183-54cb-4ce9-8250-f20338f05d07',
            width: 1600,
            height: 1024,
        },
        wikis: ['476950', '561134'],
    },
    {
        id: '182',
        name: 'The Muppets',
        color: '#7ecf73',
        image: {
            url: 'https://vignette.wikia.nocookie.net/894efa3e-a180-4b9c-b770-b8f61ba4e248',
            width: 1600,
            height: 1024,
        },
        wikis: ['831'],
    },
    {
        id: '183',
        name: 'Friends',
        color: '#51a5dd',
        image: {
            url: 'https://vignette.wikia.nocookie.net/350bbed5-d0b6-4d2e-857d-d9d616874c97',
            width: 1600,
            height: 1024,
        },
        wikis: ['1228', '15367'],
    },
    {
        id: '184',
        name: 'Minecraft Story Mode',
        color: '#2bd7b8',
        image: {
            url: 'https://vignette.wikia.nocookie.net/94100157-d681-4935-a68c-8ce7ebae42fd',
            width: 1600,
            height: 1024,
        },
        wikis: ['906247', '1105324'],
    },
    {
        id: '185',
        name: 'Xenoblade',
        color: '#1f82e4',
        image: {
            url: 'https://vignette.wikia.nocookie.net/76a8e62f-02eb-4216-b6d8-57d4c7e097fc',
            width: 1600,
            height: 1024,
        },
        wikis: ['252435', '1207786'],
    },
    {
        id: '186',
        name: 'Star Citizen',
        color: '#1e38c8',
        image: {
            url: 'https://vignette.wikia.nocookie.net/be913f4e-b4c6-47ac-844f-1406fe6d977b',
            width: 1600,
            height: 1024,
        },
        wikis: ['615822'],
    },
    {
        id: '187',
        name: 'Town of Salem',
        color: '#b09224',
        image: {
            url: 'https://vignette.wikia.nocookie.net/4a54dabb-be0c-4629-870c-d0adcee646d3',
            width: 1600,
            height: 1024,
        },
        wikis: ['941394', '1071169'],
    },
    {
        id: '188',
        name: 'Forgotten Realms',
        color: '#8c1d1f',
        image: {
            url: 'https://vignette.wikia.nocookie.net/740e9bcf-c4a8-4b0b-b269-f6d9195f1cd2',
            width: 1600,
            height: 1024,
        },
        wikis: ['691', '4482', '161987', '393477'],
    },
    {
        id: '189',
        name: 'Club Penguin',
        color: '#7ce0ff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/353008c5-97fe-4c59-b71f-9b697d9790cc',
            width: 1600,
            height: 1024,
        },
        wikis: ['2395', '3449', '137717', '661728'],
    },
    {
        id: '80',
        name: 'The Last of Us',
        color: '#415a54',
        image: {
            url: 'https://vignette.wikia.nocookie.net/da8ccd14-717e-445b-9401-324edbc4ff37',
            width: 1600,
            height: 1024,
        },
        wikis: ['435087', '441181', '685760', '812378', '817611'],
    },
    {
        id: '81',
        name: 'My Little Pony',
        color: '#8e4cad',
        image: {
            url: 'https://vignette.wikia.nocookie.net/49343c90-52aa-40cb-a7bc-80cc66317e63',
            width: 1600,
            height: 1024,
        },
        wikis: ['194308', '231674', '391801', '392862', '422332', '649441', '837618'],
    },
    {
        id: '82',
        name: 'Transformers',
        color: '#e8cb0b',
        image: {
            url: 'https://vignette.wikia.nocookie.net/acc4b55a-702b-433e-a6ef-4587d3ea4c64',
            width: 1600,
            height: 1024,
        },
        wikis: ['411', '5103', '6665', '178199'],
    },
    {
        id: '83',
        name: 'Power Rangers',
        color: '#fac46c',
        image: {
            url: 'https://vignette.wikia.nocookie.net/bae24186-2813-4a76-bbbe-5eb66daec639',
            width: 1600,
            height: 1024,
        },
        wikis: ['277', '77388', '131563', '236644'],
    },
    {
        id: '84',
        name: 'How to Train Your Dragon',
        color: '#ae1919',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ffa0bd26-76d5-476c-abd4-5a5f3a05aee7',
            width: 1600,
            height: 1024,
        },
        wikis: ['13367', '204435', '503737', '830383', '1000243', '1012153'],
    },
    {
        id: '85',
        name: 'Red Dead',
        color: '#e4151e',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e7abd3cf-494f-42fa-9d2a-bb43f8d114fc',
            width: 1600,
            height: 1024,
        },
        wikis: ['30404', '72781', '93163', '119749', '132330'],
    },
    {
        id: '86',
        name: 'Halo',
        color: '#233f4d',
        image: {
            url: 'https://vignette.wikia.nocookie.net/21b42530-7055-4d4c-995e-8dd76dfec5d1',
            width: 1600,
            height: 1024,
        },
        wikis: ['462', '3394', '3395', '3404', '3476', '3676', '159912', '676964'],
    },
    {
        id: '87',
        name: 'Godzilla',
        color: '#485042',
        image: {
            url: 'https://vignette.wikia.nocookie.net/471f540c-f395-4ebb-8a63-de68a12d3f9b',
            width: 1600,
            height: 1024,
        },
        wikis: ['528', '10405', '149730'],
    },
    {
        id: '88',
        name: 'Gears of War',
        color: '#1b384d',
        image: {
            url: 'https://vignette.wikia.nocookie.net/5d40f25b-c4f9-4c3d-be3c-2adcfc11a1bd',
            width: 1600,
            height: 1024,
        },
        wikis: ['2531', '11117'],
    },
    {
        id: '89',
        name: 'Plants vs. Zombies',
        color: '#3a8435',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ccaf437e-bcb2-4b8c-b071-38f2d03cb71c',
            width: 1600,
            height: 1024,
        },
        wikis: ['22439', '169908', '195169', '199759', '689271', '883241'],
    },
    {
        id: '190',
        name: 'Spartacus',
        color: '#582585',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e98c1fdf-b457-42bf-93a3-c47374389aa6',
            width: 1600,
            height: 1024,
        },
        wikis: ['91051', '529117', '735115'],
    },
    {
        id: '191',
        name: 'Wolfenstein',
        color: '#ce1212',
        image: {
            url: 'https://vignette.wikia.nocookie.net/4c1e336c-3576-4af9-a442-d2a770abf156',
            width: 1600,
            height: 1024,
        },
        wikis: ['4654', '474403', '721849', '888961'],
    },
    {
        id: '192',
        name: 'Love Live!',
        color: '#ce1292',
        image: {
            url: 'https://vignette.wikia.nocookie.net/508c1c18-5889-4f67-b501-0c4752bd9a5c',
            width: 1600,
            height: 1024,
        },
        wikis: ['610647', '775446', '1015917'],
    },
    {
        id: '193',
        name: 'Glee',
        color: '#ffea2e',
        image: {
            url: 'https://vignette.wikia.nocookie.net/73d94530-6e98-402d-a6da-63773f2d6933',
            width: 1600,
            height: 1024,
        },
        wikis: ['26337', '163454', '186468', '192216', '251003'],
    },
    {
        id: '194',
        name: 'Skyforge',
        color: '#1b7fb5',
        image: {
            url: 'https://vignette.wikia.nocookie.net/7f48b0c1-35c6-4264-add1-74d294bab397',
            width: 1600,
            height: 1024,
        },
        wikis: ['986810'],
    },
    {
        id: '195',
        name: 'Duck Tales',
        color: '#891e9a',
        image: {
            url: 'https://vignette.wikia.nocookie.net/572d3b70-781a-4cc7-af35-ec14a263df3c',
            width: 1600,
            height: 1024,
        },
        wikis: ['149294', '1292451', '1714622'],
    },
    {
        id: '196',
        name: 'Divergent',
        color: '#156384',
        image: {
            url: 'https://vignette.wikia.nocookie.net/bed35612-5a3e-48a6-a174-4e04fcc0a753',
            width: 1600,
            height: 1024,
        },
        wikis: ['265480', '648386', '654149', '760629', '861749', '897055'],
    },
    {
        id: '197',
        name: 'Thomas the Tank Engine',
        color: '#c0eeb7',
        image: {
            url: 'https://vignette.wikia.nocookie.net/4d28e19a-924f-4a26-9821-77ae0f2e8740',
            width: 1600,
            height: 1024,
        },
        wikis: ['2569', '1190940', '1291079'],
    },
    {
        id: '198',
        name: 'Pitch Perfect',
        color: '#1b7fb5',
        image: {
            url: 'https://vignette.wikia.nocookie.net/40678f55-b91d-43a8-b61c-c2a8f356e22f',
            width: 1600,
            height: 1024,
        },
        wikis: ['609087'],
    },
    {
        id: '199',
        name: 'Civilization',
        color: '#a58c31',
        image: {
            url: 'https://vignette.wikia.nocookie.net/7471aac1-3453-4933-bbd1-555d1c0c1c48',
            width: 1600,
            height: 1024,
        },
        wikis: ['1945', '12681', '132199', '548473', '759174'],
    },
    {
        id: '90',
        name: 'Fate/Grand Order',
        color: '#6a60c0',
        image: {
            url: 'https://vignette.wikia.nocookie.net/57fa08fa-7843-474b-8ddf-e408f65e3696',
            width: 1600,
            height: 1024,
        },
        wikis: ['1241296', '1241752'],
    },
    {
        id: '91',
        name: 'Candy Crush Saga',
        color: '#26d7ff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/e2888ac7-8006-4c2c-bf1b-dcbaea6a8528',
            width: 1600,
            height: 1024,
        },
        wikis: ['658996'],
    },
    {
        id: '92',
        name: 'Warhammer 40K',
        color: '#5969e0',
        image: {
            url: 'https://vignette.wikia.nocookie.net/40f1475c-4e0b-4d6a-9e60-24db7913ea1c',
            width: 1600,
            height: 1024,
        },
        wikis: ['501', '1368', '118480', '251986'],
    },
    {
        id: '93',
        name: 'The Vampire Diaries',
        color: '#4a573f',
        image: {
            url: 'https://vignette.wikia.nocookie.net/deb91818-1ca8-4bac-ac7f-11485a5bab28',
            width: 1600,
            height: 1024,
        },
        wikis: ['38969', '83115', '150738', '300739', '407236', '437084', '485457', '849405'],
    },
    {
        id: '94',
        name: 'Elite Dangerous',
        color: '#197bb3',
        image: {
            url: 'https://vignette.wikia.nocookie.net/ab15d7ee-6710-41f0-a4fd-f5d7398adbd1',
            width: 1600,
            height: 1024,
        },
        wikis: ['664585', '1112460'],
    },
    {
        id: '95',
        name: 'Brave Frontier',
        color: '#9e1aa1',
        image: {
            url: 'https://vignette.wikia.nocookie.net/7c921a40-7465-478b-8c7f-0b98e2c6d599',
            width: 1600,
            height: 1024,
        },
        wikis: ['841905'],
    },
    {
        id: '96',
        name: 'Simpsons Tapped Out',
        color: '#3a6abc',
        image: {
            url: 'https://vignette.wikia.nocookie.net/1a3497ef-f184-4bc8-8a23-febebcdce0fd',
            width: 1600,
            height: 1024,
        },
        wikis: ['611971', '701384'],
    },
    {
        id: '97',
        name: 'Zelda',
        color: '#ae9c61',
        image: {
            url: 'https://vignette.wikia.nocookie.net/c0377ddf-92a6-4449-9284-4f3291d2b324',
            width: 1600,
            height: 1024,
        },
        wikis: [],
    },
    {
        id: '98',
        name: 'Outlast',
        color: '#092522',
        image: {
            url: 'https://vignette.wikia.nocookie.net/5528ddcf-79e8-491c-a833-720a5e38f7b8',
            width: 1600,
            height: 1024,
        },
        wikis: ['768449', '854473', '894040'],
    },
    {
        id: '99',
        name: 'Fairytail',
        color: '#8adcff',
        image: {
            url: 'https://vignette.wikia.nocookie.net/b5f7b517-87f9-438e-af34-046d7e9bf370',
            width: 1600,
            height: 1024,
        },
        wikis: ['6276', '10345', '38926', '80264', '89210', '96196', '121040'],
    },
];
